import React, { useEffect, useRef, useState } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import { CircularProgress } from "@mui/material";
import { useShowAlert } from "../../../../../context/AlertContext";
import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import InterRegular from "../../../sale/font/Inter_24pt-Regular-normal";
import InterBold from "../../../sale/font/Inter_24pt-Bold-normal";
import { useNetwork } from "../../../../../context/NetworkContext";
import AxiosInstance from "../../../../../utils/AxiosInstance";
import uRLs from "../../../../../utils/baseUtils";
import handleError from "../../../../../constants/handleError";
import { useAuth } from "../../../../../context/AuthProvider";
import { usePermission } from "../../../../../context/PermissionContext";
import CashButton from "../../../sale/cashbtn";
import PayLaterButton from "../../../sale/PaylaterBtn";
import QRCode from "qrcode";
import { formatCurrency } from "@heartinz/finance";
import { FormatedSaleData } from "../../../../../utils/print/GlobelSaleData";
import { DownloadIcon, PrinterIcon, ShowIcon } from "../../../../../constants/Icons";
const HalfA4_1 = ({
  isViewData,
  selectedTheme,
  selectedSize,
  downloadbtn = false,
  payment = false,
}) => {
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const { permission, blockedPermissions, storeSettings, viewOption } =
    usePermission();
  const { isUser, settings } = useAuth();
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState("");
  const [terms, setTerms] = useState([]);
  const [download, setDownload] = useState(false);
  const [print, setPrint] = useState(false);
  const [error, setErrors] = useState({});
  const [isPaySettleModalOpen, setIsPaySettleModalOpen] = useState(false);
  const [isMainModalOpen, setIsMainModalOpen] = useState(true);
  const [data, setData] = useState({});
  const cashRef = useRef();
  const paylaterRef = useRef();
  const globalData = FormatedSaleData(data);
  const formatTrackMode = (salemode) => {
    switch (salemode?.toUpperCase()) {
      case "BILL":
        return "BILL RECIEPT";
      case "INVOICE":
        return "TAX INVOICE";
      default:
        return salemode;
    }
  };
  const formatCurrencyINR = (value) => {
    const formatted = Math.abs(value).toLocaleString("en-IN", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
    return value < 0 ? `-₹${formatted}` : `₹${formatted}`;
  };

  const saleDate = data?.saledate;
  const timezone = data?.saleby?.timezone;

  let saleTime = "--:--";
  if (saleDate) {
    const zoned = DateConverter.convertToTimeZone(saleDate, timezone);
    saleTime = DateConverter.ISOToDisplayFormat(zoned);
  }

  let createdTime = "--:--";
  if (data?.createdAt) {
    const zoned = DateConverter.convertToTimeZone(data.createdAt, timezone);
    createdTime = DateConverter.ISOToDisplayFormat(zoned);
  }

  const handleSaleItems = async (saleId) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`module/sale/${saleId}`);
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return null;
    }
  };

  const loadImageDimensions = (base64Src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () =>
        resolve({ width: img.naturalWidth, height: img.naturalHeight });
      img.onerror = reject;
      img.src = base64Src;
    });
  };

  // new template starts ////// **/////////////////////////////

  const urlToBase64 = async (url) => {
    const res = await fetch(url);
    const blob = await res.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const joinAddress = (...lines) =>
    lines
      .map((l) => l?.trim())
      .filter(Boolean)
      .join(", ");

  //land first half A4 invoice

  //  const generateinvoiceHalfA4PDF = async () => {
  //      const doc = new jsPDF({
  //        orientation: "landscape",
  //        unit: "mm",
  //        format: "a4",
  //      });
  //      const pageWidth = doc.internal.pageSize.getWidth();
  //      const padding = 5;
  //      const headerX = 2;
  //      const headerY = 2;
  //  const imagePath = settings?.saleProfileData?.image
  //      ? uRLs?.IMAGE_URL + "profile/" + settings?.saleProfileData?.image
  //      : "/assets/images/logo-light.png";

  //      if (data?.salefrom?.image) {
  //        try {
  //          // Convert image URL to base64
  //          const response = await fetch(imagePath);
  //          const blob = await response.blob();
  //          const base64 = await new Promise((resolve, reject) => {
  //            const reader = new FileReader();
  //            reader.onloadend = () => resolve(reader.result);
  //            reader.onerror = reject;
  //            reader.readAsDataURL(blob);
  //          });

  //          // Load original dimensions
  //          const { width: naturalWidth, height: naturalHeight } =
  //            await loadImageDimensions(base64);

  //          // Resize logic
  //          const maxWidth = 30;
  //          const maxHeight = 8;
  //          let imgWidth = naturalWidth;
  //          let imgHeight = naturalHeight;
  //          const widthRatio = maxWidth / imgWidth;
  //          const heightRatio = maxHeight / imgHeight;
  //          const ratio = Math.min(widthRatio, heightRatio);
  //          imgWidth *= ratio;
  //          imgHeight *= ratio;

  //          // Determine format
  //          const getImageFormat = (path) => {
  //            const ext = path.split(".").pop().toLowerCase();
  //            if (ext === "jpg" || ext === "jpeg") return "JPEG";
  //            if (ext === "png") return "PNG";
  //            return "JPEG";
  //          };
  //          const format = getImageFormat(imagePath);

  //          // Add image to PDF
  //          doc.addImage(
  //            base64,
  //            format,
  //            headerX + padding,
  //            headerY + padding,
  //            imgWidth,
  //            imgHeight
  //          );
  //        } catch (err) {
  //          console.warn("Image failed to load:", err);
  //        }
  //      }

  //      const invoiceFontSize = 14;
  //      doc.setFont("Inter-Bold", "bold");
  //      doc.setFontSize(invoiceFontSize);
  //      // Estimate vertical alignment by adjusting for font size
  //      const textHeightOffset = invoiceFontSize * 0.55;
  //      const invoiceTextY = headerY + textHeightOffset;
  //      const invoiceX = pageWidth - padding;
  //      const invoiceText = data.salemode && formatTrackMode(data.salemode);
  //      const invoiceTextWidth = doc.getTextWidth(invoiceText);
  //      doc.text(invoiceText, invoiceX, invoiceTextY, { align: "right" });
  //      // If cancelled, show "CANCELLED" immediately to the right of "INVOICE"
  //      if (data.status === "CANCELLED") {
  //        const cancelledFontSize = invoiceFontSize * 0.6;
  //        doc.setFontSize(cancelledFontSize);
  //        doc.setTextColor(220, 53, 69); // Bootstrap danger red
  //        doc.setFont("Inter-Bold", "bold");
  //        // Position CANCELLED right after INVOICE
  //        const cancelledX = invoiceX - invoiceTextWidth - 8; // 8 is spacing between words
  //        doc.text("CANCELLED", cancelledX, invoiceTextY, { align: "right" });
  //        // Reset styles
  //        doc.setTextColor(0, 0, 0);
  //        doc.setFontSize(invoiceFontSize);
  //      }
  //      // Prepare font size for labels and values
  //      doc.setFontSize(8);
  //      const invoiceNoLabel = "Invoice No:";
  //      const invoiceNoValue = data.saleno;
  //      const invoiceDateLabel = "Date:";
  //      const invoiceDateValue = DateConverter.ISOToDisplayFormat(
  //        data.saledate
  //      ).date;
  //      // Measure total widths
  //      const invoiceNoLabelWidth = doc.getTextWidth(invoiceNoLabel);
  //      const invoiceNoValueWidth = doc.getTextWidth(invoiceNoValue);
  //      const invoiceDateLabelWidth = doc.getTextWidth(invoiceDateLabel);
  //      const invoiceDateValueWidth = doc.getTextWidth(invoiceDateValue);
  //      const gap = 5;
  //      const innerGap = 2;
  //      const invoiceRowY = 18;
  //      const totalTextWidth =
  //        invoiceNoLabelWidth +
  //        innerGap +
  //        invoiceNoValueWidth +
  //        gap +
  //        invoiceDateLabelWidth +
  //        innerGap +
  //        invoiceDateValueWidth;
  //      const invoiceRowX = pageWidth - padding - totalTextWidth;
  //      const lineStartX = padding;
  //      const lineEndX = invoiceRowX - 5;
  //      const lineY = invoiceRowY;
  //      // Middle line
  //      doc.setDrawColor(selectedTheme?.templateTheme?.primaryColor);
  //      doc.setLineWidth(2);
  //      doc.setLineCap("round");
  //      doc.line(lineStartX, lineY, lineEndX, lineY);

  //      doc.setFont("Inter-Bold", "bold");
  //      doc.text(invoiceNoLabel, invoiceRowX, invoiceRowY);
  //      doc.setFont("Inter-Regular", "normal");
  //      doc.text(
  //        invoiceNoValue,
  //        invoiceRowX + invoiceNoLabelWidth + innerGap,
  //        invoiceRowY
  //      );
  //      const dateX =
  //        invoiceRowX + invoiceNoLabelWidth + innerGap + invoiceNoValueWidth + gap;

  //      doc.setFont("Inter-Bold", "bold");
  //      doc.text(invoiceDateLabel, dateX, invoiceRowY);

  //      doc.setFont("Inter-Regular", "normal");
  //      doc.text(
  //        invoiceDateValue,
  //        dateX + invoiceDateLabelWidth + innerGap,
  //        invoiceRowY
  //      );
  //      // --- Invoice From (between logo & title, in 2 lines) ---
  //      const topY = headerY + padding; // logo top
  //      const bottomY = invoiceTextY; // invoice title baseline
  //      const middleY = topY + (bottomY - topY) / 2; // midpoint

  //      // Line 1: Company + Address
  //      const line1 = [
  //        data.salefrom?.title || "-",
  //        [
  //          data.salefrom?.addressline1,
  //          data.salefrom?.addressline2,
  //          data.salefrom?.district,
  //          data.salefrom?.country,
  //          data.salefrom?.pincode ? `- ${data.salefrom.pincode}` : "",
  //        ]
  //          .filter(Boolean)
  //          .join(", "),
  //      ]
  //        .filter(Boolean)
  //        .join(", ");

  //      // Line 2: Phone + Email + GST + PAN + State
  //      const line2 = [
  //        data.salefrom?.phone ? `Phone: ${data.salefrom.phone}` : "",
  //        data.salefrom?.email ? `Email: ${data.salefrom.email}` : "",
  //        data.salefrom?.gstnumber ? `GST: ${data.salefrom.gstnumber}` : "",
  //        data.salefrom?.fssai ? `FSSAI: ${data.salefrom?.fssai}` : "",
  //        data.salefrom?.pannumber ? `PAN: ${data.salefrom.pannumber}` : "",
  //        data.salefrom?.state
  //          ? `State: ${data.salefrom.state} [Code: ${
  //              data.salefrom?.statecode || ""
  //            }]`
  //          : "",
  //      ]
  //        .filter(Boolean)
  //        .join("  |  ");

  //      const fromDetails = [line1, line2];

  //      // Position nicely between logo and title
  //      const leftX = padding + 35; // shift a bit right of logo
  //      const rightX = pageWidth - padding - invoiceTextWidth - 10;
  //      const availableWidth = rightX - leftX;

  //      doc.setFont("Inter-Regular", "normal");
  //      doc.setFontSize(9);

  //      fromDetails.forEach((line, i) => {
  //        doc.text(
  //          doc.splitTextToSize(line, availableWidth),
  //          leftX,
  //          middleY + i * 5
  //        );
  //      });

  //      let toY = middleY + fromDetails.length * 10;

  //      // --- Invoice To ---
  //      const hasSaleToData =
  //        data.saleto &&
  //        (data.saleto.name ||
  //          data.saleto.addressline1 ||
  //          data.saleto.addressline2 ||
  //          data.saleto.district ||
  //          data.saleto.country ||
  //          data.saleto.pincode ||
  //          data.saleto.phone ||
  //          data.saleto.email ||
  //          data.saleto.gstnumber ||
  //          data.saleto.state ||
  //          data.saleto.statecode ||
  //          data.saleto.referid);

  //      if (hasSaleToData) {
  //        doc.setFont("Inter-Bold", "bold");
  //        doc.setFontSize(10);
  //        doc.text("Invoice To:", padding, toY);

  //        toY += 5;

  //        const toDetailsLine = [
  //          data.saleto?.name || "-",
  //          [
  //            data.saleto?.addressline1,
  //            data.saleto?.addressline2,
  //            data.saleto?.district,
  //            data.saleto?.country,
  //            data.saleto?.pincode ? `- ${data.saleto.pincode}` : "",
  //          ]
  //            .filter(Boolean)
  //            .join(", "),
  //          data.saleto?.phone ? `Phone: ${data.saleto.phone}` : "",
  //          data.saleto?.email ? `Email: ${data.saleto.email}` : "",
  //          data.saleto?.gstnumber ? `GST: ${data.saleto.gstnumber}` : "",
  //          data.saleto?.state
  //            ? `State: ${data.saleto.state} [State Code: ${
  //                data.saleto?.statecode || ""
  //              }]`
  //            : "",
  //          data.saleto?.referid ? `Reference No: ${data.saleto.referid}` : "",
  //        ]
  //          .filter(Boolean)
  //          .join(", ");

  //        doc.setFont("Inter-Regular", "normal");
  //        doc.setFontSize(9);
  //        doc.text(
  //          doc.splitTextToSize(toDetailsLine, pageWidth - padding * 2),
  //          padding,
  //          toY
  //        );
  //      }

  //      // 3. Product Table
  //      const productBody = data.saleitems?.map((item, i) => {
  //        const qty = item.quantity || 1;
  //        const rate = CurrencyConverter.toCurrency(item.soldprice || 0, "INR");
  //        const total = CurrencyConverter.toCurrency(
  //          item.lineTotalSoldPrice || 0,
  //          "INR"
  //        );
  //        const gross = CurrencyConverter.toCurrency(
  //          item.lineTotalSoldPrice || 0,
  //          "INR"
  //        );
  //        const taxable = CurrencyConverter.toCurrency(
  //          item.lineTotalBasePrice || 0,
  //          "INR"
  //        );
  //        const gstAmt = CurrencyConverter.toCurrency(
  //          item.lineTotalTaxAmount || 0,
  //          "INR"
  //        );

  //        const desc = [
  //          `${item.title}`,
  //          ...(item.imode === "PRODUCT" && item.note ? [item.note] : []),
  //          ...(item.imode === "SERVICE" && item.description
  //            ? [item.description]
  //            : []),
  //          ...(item.hsnsac ? [`HSN/SAC : ${item.hsnsac}`] : []),
  //          ...(item.discount > 0
  //            ? [`MRP     : ₹${CurrencyConverter.toCurrency(item.mrp || 0, "INR")}`]
  //            : []),
  //          ...(item.discount > 0
  //            ? [
  //                `Discount: - ₹${CurrencyConverter.toCurrency(
  //                  item.discount,
  //                  "INR"
  //                )}`,
  //              ]
  //            : []),
  //          `GST     : ${item.taxpercentage}%`,
  //        ].join("\n");

  //        return [
  //          i + 1,
  //          desc,
  //          `₹${rate}`,
  //          qty,
  //          `₹${gross}`,
  //          `₹${taxable}`,
  //          `₹${gstAmt}`,
  //          `₹${total}`,
  //        ];
  //      });

  //      // Add total row INSIDE the same table
  //      productBody.push([
  //        {
  //          content: "",
  //          colSpan: 2,
  //          styles: { fontStyle: "bold", font: "Inter-Bold" },
  //        },
  //        {
  //          content: "Total",
  //          styles: { halign: "right", fontStyle: "bold", font: "Inter-Bold" },
  //        },
  //        {
  //          content: data.totalqty,
  //          styles: { fontStyle: "bold", font: "Inter-Bold" },
  //        },
  //        {
  //          content: `₹${CurrencyConverter.toCurrency(
  //            data.totalsoldprice || 0,
  //            "INR"
  //          )}`,
  //          styles: { fontStyle: "bold", font: "Inter-Bold" },
  //        },
  //        {
  //          content: `₹${CurrencyConverter.toCurrency(
  //            data.totalbaseprice || 0,
  //            "INR"
  //          )}`,
  //          styles: { fontStyle: "bold", font: "Inter-Bold" },
  //        },
  //        {
  //          content: `₹${CurrencyConverter.toCurrency(
  //            data.totaltaxamount || 0,
  //            "INR"
  //          )}`,
  //          styles: { fontStyle: "bold", font: "Inter-Bold" },
  //        },
  //        {
  //          content: `₹${CurrencyConverter.toCurrency(
  //            data.grandtotal || 0,
  //            "INR"
  //          )}`,
  //          styles: { fontStyle: "bold", font: "Inter-Bold" },
  //        },
  //      ]);

  //      const commonTableWidth = doc.internal.pageSize.getWidth() - padding * 2;

  //      autoTable(doc, {
  //        startY: Math.max(toY, toY) + 10,
  //        head: [
  //          [
  //            "S.No",
  //            "Description",
  //            "Rate",
  //            "Qty",
  //            "Gross Amount",
  //            "Taxable Value",
  //            "GST Amount",
  //            "Total",
  //          ],
  //        ],
  //        body: productBody,
  //        margin: { left: padding, right: padding },
  //        tableWidth: commonTableWidth, // ✅ same as summary
  //        styles: {
  //          font: "Inter-Regular",
  //          fontStyle: "normal",
  //          fontSize: 8,
  //          cellPadding: { top: 1, right: 2, bottom: 1, left: 2 },
  //          lineColor: selectedTheme?.templateTheme?.borderColor,
  //          lineWidth: 0.2,
  //          valign: "middle",
  //        },
  //        headStyles: {
  //          fillColor: selectedTheme?.templateTheme?.primaryColor,
  //          textColor: selectedTheme?.templateTheme?.foregroundColor,
  //          font: "Inter-Bold",
  //          fontStyle: "bold",
  //          fontSize: 8,
  //          halign: "center",
  //          valign: "middle",
  //        },
  //        columnStyles: {
  //          0: { cellWidth: commonTableWidth * 0.06, halign: "center" }, // S.No (6%)
  //          1: { cellWidth: commonTableWidth * 0.4, halign: "left" }, // 🟢 Description (40%)
  //          2: { cellWidth: commonTableWidth * 0.1, halign: "right" }, // Rate (10%)
  //          3: { cellWidth: commonTableWidth * 0.07, halign: "center" }, // Qty (7%)
  //          4: { cellWidth: commonTableWidth * 0.1, halign: "right" }, // Gross (10%)
  //          5: { cellWidth: commonTableWidth * 0.11, halign: "right" }, // Taxable (11%)
  //          6: { cellWidth: commonTableWidth * 0.08, halign: "right" }, // GST (8%)
  //          7: { cellWidth: commonTableWidth * 0.08, halign: "right" }, // Total (8%)
  //        },

  //        theme: "grid",
  //      });

  //      const isInterState =
  //        data.salefrom?.statecode &&
  //        data.saleto?.statecode &&
  //        data.salefrom.statecode !== data.saleto.statecode;
  //      const body = [
  //        [
  //          {
  //            content: "Total Amount In Words",
  //            styles: {
  //              fontStyle: "bold",
  //              font: "Inter-Bold",
  //              fontSize: 9,
  //              valign: "top",
  //            },
  //          },
  //          {
  //            content: "Total Amount Before Tax",
  //            styles: { halign: "right", fontSize: 9 },
  //          },
  //          {
  //            content: `₹${CurrencyConverter.toCurrency(
  //              data.totalbaseprice || 0,
  //              "INR"
  //            )}`,
  //            styles: { halign: "center", valign: "middle", fontSize: 9 },
  //          },
  //        ],
  //        [
  //          {
  //            content: data.amountinwords,
  //            rowSpan: isInterState ? 3 : 4,
  //            styles: {
  //              halign: "center",
  //              valign: "middle",
  //              fontSize: 9,
  //            },
  //          },
  //          {
  //            content: isInterState ? "IGST" : "SGST",
  //            styles: { halign: "right", fontSize: 9 },
  //          },
  //          {
  //            content: `₹${CurrencyConverter.toCurrency(
  //              isInterState ? data.igstamount || 0 : data.sgstamount || 0,
  //              "INR"
  //            )}`,
  //            styles: { halign: "center", valign: "middle", fontSize: 9 },
  //          },
  //        ],
  //      ];
  //      if (!isInterState) {
  //        body.push([
  //          { content: "CGST", styles: { halign: "right", fontSize: 9 } },
  //          {
  //            content: `₹${CurrencyConverter.toCurrency(
  //              data.cgstamount || 0,
  //              "INR"
  //            )}`,
  //            styles: { halign: "center", valign: "middle", fontSize: 9 },
  //          },
  //        ]);
  //      }
  //      // Add Total row
  //      body.push([
  //        { content: "Total", styles: { halign: "right", fontSize: 9 } },
  //        {
  //          content: `₹${CurrencyConverter.toCurrency(
  //            data.totalsoldprice || 0,
  //            "INR"
  //          )}`,
  //          styles: { halign: "center", valign: "middle", fontSize: 9 },
  //        },
  //      ]);
  //      // Add Grand Total row
  //      body.push([
  //        {
  //          content: "Grand Total (Rounded)",
  //          styles: { fontStyle: "bold", halign: "right", fontSize: 9 },
  //        },
  //        {
  //          content: `₹ ${CurrencyConverter.toCurrency(
  //            data.grandtotal || 0,
  //            "INR"
  //          )}`,
  //          styles: {
  //            halign: "center",
  //            valign: "middle",
  //            fontStyle: "bold",
  //            fontSize: 10,
  //          },
  //        },
  //      ]);
  //      const afterProductsY = doc.lastAutoTable?.finalY;
  //      const pageHeight = doc.internal.pageSize.getHeight();
  //      const marginBottom = 20;
  //      const estimatedSummaryHeight = 50;
  //      let summaryStartY;
  //      let isSamePage = true;
  //      if (afterProductsY + estimatedSummaryHeight + marginBottom <= pageHeight) {
  //        summaryStartY = afterProductsY;
  //      } else {
  //        doc.addPage();
  //        summaryStartY = 20;
  //        isSamePage = false;
  //      }
  //      // ✅ Summary table
  //      autoTable(doc, {
  //        startY: summaryStartY,
  //        body: body,
  //        pageBreak: "avoid",
  //        margin: { left: padding, right: padding },
  //        tableWidth: commonTableWidth, // ✅ same width as products
  //        styles: {
  //          font: "Inter-Regular",
  //          fontStyle: "normal",
  //          halign: "middle",
  //          cellPadding: 2,
  //          fontSize: 8,
  //          lineColor: selectedTheme?.templateTheme?.borderColor,
  //          lineWidth: 0.2,
  //          textColor: selectedTheme?.templateTheme?.foregroundColor,
  //          fillColor: selectedTheme?.templateTheme?.primaryColor,
  //        },
  //        columnStyles: {
  //          0: { cellWidth: commonTableWidth * 0.56 }, // left block (Amount in Words)
  //          1: { cellWidth: commonTableWidth * 0.36, halign: "right" }, // reduced width
  //          2: { cellWidth: commonTableWidth * 0.08, halign: "center" }, // slightly wider for values
  //        },

  //        didParseCell: function (data) {
  //          const lastRowIndex = body.length - 1;
  //          if (data.section === "body") {
  //            if (
  //              data.row.index === lastRowIndex &&
  //              (data.column.index === 1 || data.column.index === 2)
  //            ) {
  //              // data.cell.styles.fillColor = "#f4f4f6";
  //              // data.cell.styles.textColor = [0, 0, 0];
  //              data.cell.styles.font = "Inter-Bold";
  //              data.cell.styles.fontStyle = "bold";
  //            } else {
  //              data.cell.styles.fillColor = "#ffffff";
  //              data.cell.styles.textColor = [0, 0, 0];
  //              data.cell.styles.font = "Inter-Regular";
  //              data.cell.styles.fontStyle = "normal";
  //            }
  //          }
  //        },
  //        theme: "grid",
  //      });

  //      const afterSummaryY = doc.lastAutoTable.finalY;
  //      const pageHeight2 = doc.internal.pageSize.getHeight();
  //      const marginBottom2 = 20;
  //      const declarationHeight = 45;
  //      let finalY;
  //      if (afterSummaryY + declarationHeight + marginBottom2 > pageHeight2) {
  //        doc.addPage();
  //        finalY = 10;
  //      } else {
  //        finalY = afterSummaryY;
  //      }
  //      let currentY = finalY + 10;

  //      if (parseFloat(data?.totaldiscount) > 0) {
  //        doc.setFont("Inter-Bold", "bold");
  //        doc.setFontSize(10);
  //        doc.text(
  //          `Your Total Discount : ₹${CurrencyConverter.toCurrency(
  //            data?.totaldiscount || 0,
  //            "INR"
  //          )}`,
  //          pageWidth / 2,
  //          currentY,
  //          { align: "center" }
  //        );

  //        currentY += 2; // ONLY if discount exists
  //      }

  //      // ---------------- PAYMENT MODE TABLE (LEFT – 2 INCH STYLE) ----------------

  //      const paymentRows = [];

  //      const cashPaid = (data?.cashamount || 0) - (data?.cashchange || 0);

  //      const cardPaid = (data?.cardamount || 0) - (data?.cardchange || 0);

  //      const onlinePaid = (data?.onlineamount || 0) - (data?.onlinechange || 0);

  //      const upiPaid = (data?.upiamount || 0) - (data?.upichange || 0);

  //      const balanceDue =
  //        (data?.paylateramount || 0) - (data?.paylaterchange || 0);

  //      // condition based rows
  //      if (cashPaid > 0) {
  //        paymentRows.push([
  //          "Cash",
  //          `₹${CurrencyConverter.toCurrency(cashPaid, "INR")}`,
  //        ]);
  //      }

  //      if (cardPaid > 0) {
  //        paymentRows.push([
  //          "Card",
  //          `₹${CurrencyConverter.toCurrency(cardPaid, "INR")}`,
  //        ]);
  //      }

  //      if (onlinePaid > 0) {
  //        paymentRows.push([
  //          "Online Amount",
  //          `₹${CurrencyConverter.toCurrency(onlinePaid, "INR")}`,
  //        ]);
  //      }

  //      if (upiPaid > 0) {
  //        paymentRows.push([
  //          "UPI",
  //          `₹${CurrencyConverter.toCurrency(upiPaid, "INR")}`,
  //        ]);
  //      }

  //      if (balanceDue > 0) {
  //        paymentRows.push([
  //          "Balance Due",
  //          `₹${CurrencyConverter.toCurrency(balanceDue, "INR")}`,
  //        ]);
  //      }

  //      // draw table ONLY if rows exist
  //      if (paymentRows?.length > 0) {
  //        autoTable(doc, {
  //          startY: currentY,
  //          head: [["Payment Mode", ""]],
  //          body: paymentRows,
  //          margin: { left: 6 },
  //          tableWidth: 70,
  //          styles: {
  //            font: "Inter-Regular",
  //            fontSize: 8,
  //            cellPadding: 2,
  //            lineColor: selectedTheme?.templateTheme?.borderColor,
  //            lineWidth: 0.2,
  //            textColor: "#000",
  //          },
  //          headStyles: {
  //            fillColor: selectedTheme?.templateTheme?.primaryColor,
  //            textColor: selectedTheme?.templateTheme?.foregroundColor,
  //            font: "Inter-Bold",
  //            fontStyle: "bold",
  //            halign: "center",
  //          },
  //          columnStyles: {
  //            0: { cellWidth: 40, halign: "left" },
  //            1: { cellWidth: 30, halign: "right" },
  //          },
  //          theme: "grid",
  //        });

  //        currentY = doc.lastAutoTable.finalY + 6;
  //      }

  //      doc.setFont("Inter-Bold", "bold");
  //      doc.setFontSize(10);
  //      doc.text("***** Thank You! Visit Us Again *****", pageWidth / 2, currentY, {
  //        align: "center",
  //      });
  //      if (storeSettings?.negobillBranding) {
  //        currentY += 5;
  //        doc.setFont("Inter-Bold", "bold");
  //        doc.setFontSize(10);
  //        doc.text("Powerd By", pageWidth / 2, currentY, { align: "center" });
  //        currentY += 5;
  //        doc.setFont("Inter-Bold", "bold");
  //        doc.setFontSize(10);
  //        doc.text("www.NegoBill.com", pageWidth / 2, currentY, {
  //          align: "center",
  //        });
  //      }
  //      currentY += 8;

  //      if (terms?.length > 0) {
  //        doc.setFont("Inter-Bold", "bold");
  //        doc.setFontSize(9);
  //        doc.text("Terms & Conditions", 10, currentY);

  //        doc.setFont("Inter-Regular", "normal");
  //        doc.setFontSize(7);
  //        doc.text(terms, 13, currentY + 4);
  //      }
  //      const rightXs = pageWidth - padding;

  //      const boxTopY = currentY + 3;
  //      // const boxTopY = footerY + 7;
  //      const boxHeight = 20;
  //      const boxLeftX = padding;
  //      const boxRightX = pageWidth - padding;
  //      const boxWidth = boxRightX - boxLeftX;
  //      const boxMidX = boxLeftX + boxWidth / 2;
  //      doc.setFontSize(8);
  //      doc.setFont("Inter-Regular", "normal");
  //      const titleWidths = doc.getTextWidth("Issued By,Signature");
  //      const titleText = String(data?.salefrom?.title || "");
  //      doc.text("Issued By,Signature", rightXs, boxTopY, { align: "right" });
  //      doc.setFontSize(9);
  //      doc.setFont("Inter-Bold", "bold");
  //      doc.text(titleText, rightXs, boxTopY + 4, { align: "right" });
  //      const signimg = uRLs.IMAGE_URL + storeSettings?.invoiceSettings?.signature;
  //      if (storeSettings?.invoiceSettings?.signature) {
  //        try {
  //          // Convert image URL to base64
  //          const response = await fetch(signimg);
  //          const blob = await response.blob();
  //          const base64 = await new Promise((resolve, reject) => {
  //            const reader = new FileReader();
  //            reader.onloadend = () => resolve(reader.result);
  //            reader.onerror = reject;
  //            reader.readAsDataURL(blob);
  //          });

  //          // Load original dimensions
  //          const { width: naturalWidth, height: naturalHeight } =
  //            await loadImageDimensions(base64);

  //          // Resize logic
  //          const maxWidth = 50;
  //          const maxHeight = 10;
  //          let imgWidth = naturalWidth;
  //          let imgHeight = naturalHeight;
  //          const widthRatio = maxWidth / imgWidth;
  //          const heightRatio = maxHeight / imgHeight;
  //          const ratio = Math.min(widthRatio, heightRatio);
  //          imgWidth *= ratio;
  //          imgHeight *= ratio;

  //          const getImageFormat = (path) => {
  //            const ext = path.split(".").pop().toLowerCase();
  //            if (ext === "jpg" || ext === "jpeg") return "JPEG";
  //            if (ext === "png") return "PNG";
  //            return "JPEG";
  //          };
  //          const format = getImageFormat(signimg);
  //          const imgX = rightXs - imgWidth;
  //          doc.addImage(base64, format, imgX, boxTopY + 6, imgWidth, imgHeight);
  //        } catch (err) {
  //          console.warn("Image failed to load:", err);
  //        }
  //      }
  //      setDownload(false);
  //      // setPrint(false);
  //      return doc;
  //    };
  const generateinvoiceHalfA4PDF = async () => {
    const doc = new jsPDF("p", "mm", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    const padding = 5;
    const headerX = 2;
    const headerY = 2;
    const HALF_PAGE_HEIGHT = 140;
    const imagePath = settings?.saleProfileData?.image
      ? uRLs?.IMAGE_URL + "profile/" + settings?.saleProfileData?.image
      : "/assets/images/logo-light.png";
    if (globalData?.salefrom?.image) {
      try {
        // Convert image URL to base64
        const response = await fetch(imagePath);
        const blob = await response.blob();
        const base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });

        // Load original dimensions
        const { width: naturalWidth, height: naturalHeight } =
          await loadImageDimensions(base64);

        // Resize logic
        const maxWidth = 30;
        const maxHeight = 8;
        let imgWidth = naturalWidth;
        let imgHeight = naturalHeight;
        const widthRatio = maxWidth / imgWidth;
        const heightRatio = maxHeight / imgHeight;
        const ratio = Math.min(widthRatio, heightRatio);
        imgWidth *= ratio;
        imgHeight *= ratio;

        // Determine format
        const getImageFormat = (path) => {
          const ext = path.split(".").pop().toLowerCase();
          if (ext === "jpg" || ext === "jpeg") return "JPEG";
          if (ext === "png") return "PNG";
          return "JPEG";
        };
        const format = getImageFormat(imagePath);

        // Add image to PDF
        doc.addImage(base64, format, padding, padding, imgWidth, imgHeight);
      } catch (err) {
        console.warn("Image failed to load:", err);
      }
    }

    const invoiceFontSize = 9;
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(invoiceFontSize);
    // Estimate vertical alignment by adjusting for font size
    const textHeightOffset = invoiceFontSize * 0.55;
    const invoiceTextY = headerY + textHeightOffset;
    const invoiceX = pageWidth - padding;
    const invoiceText =
      globalData.salemode && formatTrackMode(globalData.salemode);
    const invoiceTextWidth = doc.getTextWidth(invoiceText);
    doc.text(invoiceText, invoiceX, invoiceTextY, { align: "right" });
    // If cancelled, show "CANCELLED" immediately to the right of "INVOICE"
    if (data?.status === "CANCELLED") {
      const cancelledFontSize = invoiceFontSize * 0.6;
      doc.setFontSize(cancelledFontSize);
      doc.setTextColor(220, 53, 69); // Bootstrap danger red
      doc.setFont("Inter-Bold", "bold");
      // Position CANCELLED right after INVOICE
      const cancelledX = invoiceX - invoiceTextWidth - 8; // 8 is spacing between words
      doc.text("CANCELLED", cancelledX, invoiceTextY, { align: "right" });
      // Reset styles
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(invoiceFontSize);
    }

    // Prepare font size for labels and values
    doc.setFontSize(7);
    const invoiceNoLabel = "Invoice No:";
    const invoiceNoValue = globalData.saleno;
    const invoiceDateLabel = "Date:";
    const invoiceDateValue = DateConverter.ISOToDisplayFormat(
      data.saledate
    ).date;
    // Measure total widths
    const invoiceNoLabelWidth = doc.getTextWidth(invoiceNoLabel);
    const invoiceNoValueWidth = doc.getTextWidth(invoiceNoValue);
    const invoiceDateLabelWidth = doc.getTextWidth(invoiceDateLabel);
    const invoiceDateValueWidth = doc.getTextWidth(invoiceDateValue);
    const gap = 5;
    const innerGap = 2;
    const invoiceRowY = 15;
    const totalTextWidth =
      invoiceNoLabelWidth +
      innerGap +
      invoiceNoValueWidth +
      gap +
      invoiceDateLabelWidth +
      innerGap +
      invoiceDateValueWidth;
    const invoiceRowX = pageWidth - padding - totalTextWidth;
    const lineStartX = padding;
    const lineEndX = invoiceRowX - 5;
    const lineY = invoiceRowY;
    // Middle line
    doc.setDrawColor(selectedTheme?.templateTheme?.primaryColor);
    doc.setLineWidth(2);
    doc.setLineCap("round");
    doc.line(lineStartX, lineY, lineEndX, lineY);

    doc.setFont("Inter-Bold", "bold");
    doc.text(invoiceNoLabel, invoiceRowX, invoiceRowY);
    doc.setFont("Inter-Regular", "normal");
    doc.text(
      invoiceNoValue,
      invoiceRowX + invoiceNoLabelWidth + innerGap,
      invoiceRowY
    );
    const dateX =
      invoiceRowX + invoiceNoLabelWidth + innerGap + invoiceNoValueWidth + gap;

    doc.setFont("Inter-Bold", "bold");
    doc.text(invoiceDateLabel, dateX, invoiceRowY);

    doc.setFont("Inter-Regular", "normal");
    doc.text(
      invoiceDateValue,
      dateX + invoiceDateLabelWidth + innerGap,
      invoiceRowY
    );
    // --- Invoice From (between logo & title, in 2 lines) ---
    const topY = headerY + padding; // logo top
    const bottomY = invoiceTextY; // invoice title baseline
    const middleY = topY + (bottomY - topY) / 2; // midpoint

    // Line 1: Company + Address
    const line1 = [
      globalData?.salefrom?.title || "-",
      [
        globalData?.salefrom?.addressline1,
        globalData?.salefrom?.addressline2,
        globalData?.salefrom?.district,
        globalData?.salefrom?.state,
        //  globalData?.salefrom?.country,
        globalData?.salefrom?.pincode
          ? `- ${globalData?.salefrom.pincode}`
          : "",
        globalData?.salefrom?.phone
          ? `Phone: ${globalData?.salefrom.phone}`
          : "",
        globalData?.salefrom?.email
          ? `Email: ${globalData?.salefrom.email}`
          : "",
        globalData?.salefrom?.gstnumber
          ? `GST: ${globalData?.salefrom.gstnumber}`
          : "",
      ]
        .filter(Boolean)
        .join(", "),
    ]
      .filter(Boolean)
      .join(", ");

    // Line 2: Phone + Email + GST + PAN + State
    //  const line2 = [
    //    data.salefrom?.phone ? `Phone: ${data.salefrom.phone}` : "",
    //    data.salefrom?.email ? `Email: ${data.salefrom.email}` : "",
    //    data.salefrom?.gstnumber ? `GST: ${data.salefrom.gstnumber}` : "",
    //   //  data.salefrom?.fssai ? `FSSAI: ${data.salefrom?.fssai}` : "",
    //   //  data.salefrom?.pannumber ? `PAN: ${data.salefrom.pannumber}` : "",

    //  ]
    //    .filter(Boolean)
    //    .join("  |  ");

    const fromDetails = [line1];
    // Position nicely between logo and title
    const leftX = padding + 35; // shift a bit right of logo
    const rightX = pageWidth - padding - invoiceTextWidth - 10;
    const availableWidth = rightX - leftX - 5;
    let currentY = middleY;
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(7);
    fromDetails.forEach((line) => {
      const wrappedLine = doc.splitTextToSize(line, availableWidth);
      doc.text(wrappedLine, leftX, currentY, { align: "left" });
      currentY += wrappedLine.length * 4;
    });

    //  fromDetails.forEach((line, i) => {
    //    doc.text(
    //      doc.splitTextToSize(line, availableWidth),
    //      leftX,
    //      middleY + i * 5
    //    );
    //  });

    let toY = invoiceRowY + 6;
    // --- Invoice To ---
    const hasSaleToData =
      globalData.saleto &&
      (globalData.saleto.name ||
        globalData.saleto.addressline1 ||
        globalData.saleto.addressline2 ||
        globalData.saleto.district ||
        globalData.saleto.country ||
        globalData.saleto.pincode ||
        globalData.saleto.phone ||
        globalData.saleto.email ||
        globalData.saleto.gstnumber ||
        globalData.saleto.state ||
        globalData.saleto.statecode ||
        globalData.saleto.referid);

    if (hasSaleToData) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8.5);
      doc.text("Invoice To:", padding, toY);

      toY += 3;

      const toDetailsLine = [
        globalData.saleto?.name || "-",
        [
          globalData.saleto?.addressline1,
          globalData.saleto?.addressline2,
          globalData.saleto?.district,
          globalData.saleto?.statecode,
          //  globalData.saleto?.country,
          globalData.saleto?.pincode ? `- ${globalData.saleto.pincode}` : "",
        ]
          .filter(Boolean)
          .join(", "),
        globalData.saleto?.phone ? `Phone: ${globalData.saleto.phone}` : "",
        globalData.saleto?.email ? `Email: ${globalData.saleto.email}` : "",
        globalData.saleto?.gstnumber
          ? `GST: ${globalData.saleto.gstnumber}`
          : "",

        //  data.saleto?.referid ? `Reference No: ${data.saleto.referid}` : "",
      ]
        .filter(Boolean)
        .join(", ");

      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(7);
      const wrappedAddress = doc.splitTextToSize(
        toDetailsLine,
        pageWidth - padding * 2
      );

      // 2. Draw the wrapped text
      doc.text(wrappedAddress, padding, toY);

      // 3. IMPORTANT: Update toY based on the number of wrapped lines
      // This ensures the table starts BELOW the address
      toY += wrappedAddress.length * 3;
    }

    // 3. Product Table
    const productBody = globalData.saleitems?.map((item, i) => {
      const qty = item.quantity || 1;
      const rate = item.soldprice;
      const total = item.lineTotalSoldPrice;
      const gross = item.lineTotalSoldPrice;
      const taxable = item.lineTotalBasePrice;
      const gstAmt = item.lineTotalTaxAmount;
      const landingCost = item.lineTotalLandingCost;

      const desc = [
        `${item.title}`,
        ...(item.imode === "PRODUCT" && item.note ? [item.note] : []),
        ...(item.imode === "SERVICE" && item.description
          ? [item.description]
          : []),
        ...(item.hsnsac ? [`HSN/SAC : ${item.hsnsac}`] : []),
        ...(item.discount > 0 ? [`MRP     : ₹${item.mrp}`] : []),
        ...(item.discount > 0 ? [`Discount: - ₹${item.discount}`] : []),
        `GST     : ${item.taxpercentage}%`,
      ].join("\n");

      return [
        i + 1,
        desc,
        `₹${rate}`,
        `${qty} ${(() => {
          const unitCode = item?.isSecondaryUnit
            ? item?.unitConfig?.secondaryUnitCode
            : item?.unitConfig?.primaryUnitCode;
          return unitCode || "";
        })()}`,
        `₹${gross}`,
        `₹${taxable}`,
        `₹${gstAmt}`,
        `₹${total}`,
      ];
    });

    // Add total row INSIDE the same table
    productBody.push([
      {
        content: "",
        colSpan: 2,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: "Total",
        styles: { halign: "right", fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: "",
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: `₹${globalData?.totalsoldprice}`,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: `₹${globalData?.totalbaseprice}`,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: `₹${globalData?.totaltaxamount}`,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: `₹${globalData?.grandtotal}`,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
    ]);

    const commonTableWidth = doc.internal.pageSize.getWidth() - padding * 2;

    autoTable(doc, {
      startY: toY,
      head: [
        [
          "S.No",
          "Description",
          "Rate",
          "Qty",
          "Gross Amount",
          "Taxable Value",
          "GST Amount",
          "Total",
        ],
      ],
      body: productBody,
      margin: {
        left: padding,
        right: padding,
        bottom: pageH - HALF_PAGE_HEIGHT + padding,
      },
      tableWidth: commonTableWidth, // ✅ same as summary
      styles: {
        font: "Inter-Regular",
        fontStyle: "normal",
        fontSize: 6.5,
        cellPadding: { top: 1, right: 2, bottom: 1, left: 2 },
        lineColor: selectedTheme?.templateTheme?.borderColor,
        lineWidth: 0.2,
        valign: "middle",
      },
      headStyles: {
        fillColor: selectedTheme?.templateTheme?.primaryColor,
        textColor: selectedTheme?.templateTheme?.foregroundColor,
        font: "Inter-Bold",
        fontStyle: "bold",
        fontSize: 7,
        halign: "center",
        valign: "middle",
      },
      columnStyles: {
        0: { cellWidth: commonTableWidth * 0.06, halign: "center" }, // S.No (6%)
        1: { cellWidth: commonTableWidth * 0.4, halign: "left" }, // 🟢 Description (40%)
        2: { cellWidth: commonTableWidth * 0.1, halign: "right" }, // Rate (10%)
        3: { cellWidth: commonTableWidth * 0.07, halign: "center" }, // Qty (7%)
        4: { cellWidth: commonTableWidth * 0.1, halign: "right" }, // Gross (10%)
        5: { cellWidth: commonTableWidth * 0.11, halign: "right" }, // Taxable (11%)
        6: { cellWidth: commonTableWidth * 0.08, halign: "right" }, // GST (8%)
        7: { cellWidth: commonTableWidth * 0.08, halign: "right" }, // Total (8%)
      },

      theme: "grid",
    });

    const isInterState =
      globalData?.salefrom?.statecode &&
      globalData?.saleto?.statecode &&
      globalData?.salefrom.statecode !== globalData?.saleto.statecode;
    const body = [
      [
        {
          content: "Total Amount In Words",
          styles: {
            fontStyle: "bold",
            font: "Inter-Bold",
            fontSize: 8,
            valign: "top",
          },
        },
        {
          content: "Total Amount Before Tax",
          styles: { halign: "right", fontSize: 9 },
        },
        {
          content: `₹${globalData.totalbaseprice}`,
          styles: { halign: "center", valign: "middle", fontSize: 9 },
        },
      ],
      [
        {
          content: globalData.amountinwords,
          rowSpan: isInterState ? 3 : 4,
          styles: {
            halign: "center",
            valign: "middle",
            fontSize: 8,
          },
        },
        {
          content: isInterState ? "IGST" : "SGST",
          styles: { halign: "right", fontSize: 8 },
        },
        {
          content: `₹${
            isInterState ? globalData.igstamount || 0 : globalData.sgstamount
          }`,
          styles: { halign: "center", valign: "middle", fontSize: 8 },
        },
      ],
    ];
    if (!isInterState) {
      body.push([
        { content: "CGST", styles: { halign: "right", fontSize: 8 } },
        {
          content: `₹${globalData.cgstamount}`,
          styles: { halign: "center", valign: "middle", fontSize: 8 },
        },
      ]);
    }
    // Add Total row
    body.push([
      { content: "Total", styles: { halign: "right", fontSize: 8 } },
      {
        content: `₹${globalData.totalsoldprice}`,
        styles: { halign: "center", valign: "middle", fontSize: 8 },
      },
    ]);
    // Add Grand Total row
    body.push([
      {
        content: "Grand Total (Rounded)",
        styles: { fontStyle: "bold", halign: "right", fontSize: 8 },
      },
      {
        content: `₹${globalData.grandtotal}`,
        styles: {
          halign: "center",
          valign: "middle",
          fontStyle: "bold",
          fontSize: 9,
        },
      },
    ]);
    const afterProductsY = doc.lastAutoTable?.finalY;
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginBottom = 20;
    const estimatedSummaryHeight = 50;
    let summaryStartY;
    let isSamePage = true;
    if (afterProductsY + estimatedSummaryHeight + marginBottom <= pageHeight) {
      summaryStartY = afterProductsY;
    } else {
      doc.addPage();
      summaryStartY = 20;
      isSamePage = false;
    }
    autoTable(doc, {
      startY: summaryStartY,
      body: body,
      pageBreak: "avoid",
      margin: { left: padding, right: padding },
      tableWidth: commonTableWidth, // same width as products
      styles: {
        font: "Inter-Regular",
        fontStyle: "normal",
        halign: "middle",
        cellPadding: 1.3,
        fontSize: 7,
        lineColor: selectedTheme?.templateTheme?.borderColor,
        lineWidth: 0.2,
        textColor: selectedTheme?.templateTheme?.foregroundColor,
        fillColor: selectedTheme?.templateTheme?.primaryColor,
      },
      columnStyles: {
        0: { cellWidth: commonTableWidth * 0.56 }, // left block (Amount in Words)
        1: { cellWidth: commonTableWidth * 0.36, halign: "right" }, // reduced width
        2: { cellWidth: commonTableWidth * 0.08, halign: "center" }, // slightly wider for values
      },

      didParseCell: function (data) {
        const lastRowIndex = body.length - 1;
        if (data?.section === "body") {
          if (
            data?.row.index === lastRowIndex &&
            (data.column.index === 1 || data.column.index === 2)
          ) {
            // data.cell.styles.fillColor = "#f4f4f6";
            // data.cell.styles.textColor = [0, 0, 0];
            data.cell.styles.font = "Inter-Bold";
            data.cell.styles.fontStyle = "bold";
          } else {
            data.cell.styles.fillColor = "#ffffff";
            data.cell.styles.textColor = [0, 0, 0];
            data.cell.styles.font = "Inter-Regular";
            data.cell.styles.fontStyle = "normal";
          }
        }
      },
      theme: "grid",
    });

    const afterSummaryY = doc.lastAutoTable.finalY;
    const pageHeight2 = doc.internal.pageSize.getHeight();
    const marginBottom2 = 20;
    const declarationHeight = 45;
    let finalY;
    if (afterSummaryY + declarationHeight + marginBottom2 > pageHeight2) {
      doc.addPage();
      finalY = 10;
    } else {
      finalY = afterSummaryY;
    }
    currentY = finalY + 4;

    if (globalData?.totaldiscount > 0) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(7);
      doc.text(
        `Your Total Discount : ₹${globalData?.totaldiscount}`,
        pageWidth / 2,
        currentY,
        { align: "center" }
      );

      currentY += 2; // ONLY if discount exists
    }

    const paymentRows = [];

    const cashPaid = (data?.cashamount || 0) - (data?.cashchange || 0);

    const cardPaid = (data?.cardamount || 0) - (data?.cardchange || 0);

    const onlinePaid = (data?.onlineamount || 0) - (data?.onlinechange || 0);

    const upiPaid = (data?.upiamount || 0) - (data?.upichange || 0);

    const balanceDue =
      (data?.paylateramount || 0) - (data?.paylaterchange || 0);

    // condition based rows
    if (globalData?.cashPaid > 0) {
      paymentRows.push(["Cash", `₹${globalData?.cashPaid}`]);
    }

    if (globalData?.cardPaid > 0) {
      paymentRows.push(["Card", `₹${globalData?.cardPaid}`]);
    }

    if (globalData?.onlinePaid > 0) {
      paymentRows.push(["Online Amount", `₹${globalData?.onlinePaid}`]);
    }

    if (globalData?.upiPaid > 0) {
      paymentRows.push(["UPI", `₹${globalData?.upiPaid}`]);
    }

    if (globalData?.balanceDue > 0) {
      paymentRows.push(["Balance Due", `₹${globalData?.balanceDue}`]);
    }
    //  if (paymentRows?.length > 0) {
    //    autoTable(doc, {
    //      startY: currentY,
    //      head: [["Payment Mode", ""]],
    //      body: paymentRows,
    //      margin: { left: 6 },
    //      tableWidth: 70,
    //      styles: {
    //        font: "Inter-Regular",
    //        fontSize: 8,
    //        cellPadding: 2,
    //        lineColor: selectedTheme?.templateTheme?.borderColor,
    //        lineWidth: 0.2,
    //        textColor: "#000",
    //      },
    //      headStyles: {
    //        fillColor: selectedTheme?.templateTheme?.primaryColor,
    //        textColor: selectedTheme?.templateTheme?.foregroundColor,
    //        font: "Inter-Bold",
    //        fontStyle: "bold",
    //        halign: "center",
    //      },
    //      columnStyles: {
    //        0: { cellWidth: 40, halign: "left" },
    //        1: { cellWidth: 30, halign: "right" },
    //      },
    //      theme: "grid",
    //    });

    //    currentY = doc.lastAutoTable.finalY + 6;
    //  }

    //  doc.setFont("Inter-Bold", "bold");
    //  doc.setFontSize(10);
    //  doc.text("***** Thank You! Visit Us Again *****", pageWidth / 2, currentY, {
    //    align: "center",
    //  });
    if (storeSettings?.negobillBranding) {
      currentY += 1;
      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(6);
      doc.text("Powerd By", pageWidth / 2, currentY, { align: "center" });
      currentY += 3;
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(6);
      doc.text("www.NegoBill.com", pageWidth / 2, currentY, {
        align: "center",
      });
    }
    //  currentY += 2;
    //  const terms=storeSettings?.invoiceSettings?.termsAndConditions;
    //  if (terms?.length > 0) {
    //    doc.setFont("Inter-Bold", "bold");
    //    doc.setFontSize(9);
    //    doc.text("Terms & Conditions", 10, currentY);

    //    doc.setFont("Inter-Regular", "normal");
    //    doc.setFontSize(7);
    //    doc.text(terms, 13, currentY + 4);
    //  }
    const rightXs = pageWidth - padding;

    const boxTopY = currentY - padding;
    // const boxTopY = footerY + 7;
    const boxHeight = 20;
    const boxLeftX = padding;
    const boxRightX = pageWidth - padding;
    const boxWidth = boxRightX - boxLeftX;
    const boxMidX = boxLeftX + boxWidth / 2;
    doc.setFontSize(7);
    doc.setFont("Inter-Regular", "normal");
    //  const titleWidths = doc.getTextWidth("Issued By,Signature");
    //  const titleText = String(data?.salefrom?.title || "");
    doc.text("Issued By,Signature", rightXs, boxTopY, { align: "right" });
    //  doc.setFontSize(9);
    //  doc.setFont("Inter-Bold", "bold");
    //  doc.text(titleText, rightXs, boxTopY + 4, { align: "right" });
    const signimg = uRLs.IMAGE_URL + storeSettings?.invoiceSettings?.signature;
    if (storeSettings?.invoiceSettings?.signature) {
      try {
        // Convert image URL to base64
        const response = await fetch(signimg);
        const blob = await response.blob();
        const base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });

        // Load original dimensions
        const { width: naturalWidth, height: naturalHeight } =
          await loadImageDimensions(base64);

        // Resize logic
        const maxWidth = 50;
        const maxHeight = 10;
        let imgWidth = naturalWidth;
        let imgHeight = naturalHeight;
        const widthRatio = maxWidth / imgWidth;
        const heightRatio = maxHeight / imgHeight;
        const ratio = Math.min(widthRatio, heightRatio);
        imgWidth *= ratio;
        imgHeight *= ratio;

        const getImageFormat = (path) => {
          const ext = path.split(".").pop().toLowerCase();
          if (ext === "jpg" || ext === "jpeg") return "JPEG";
          if (ext === "png") return "PNG";
          return "JPEG";
        };
        const format = getImageFormat(signimg);
        const imgX = rightXs - imgWidth + padding;
        doc.addImage(base64, format, imgX, boxTopY + 1, imgWidth, imgHeight);
      } catch (err) {
        console.warn("Image failed to load:", err);
      }
    }
    //    setDownload(false);
    // setPrint(false);
    return doc;
  };
  //and first half A4 bill

  //  const generateBillHalfA4PDF = async () => {
  //    const doc = new jsPDF({
  //      orientation: "landscape",
  //      unit: "mm",
  //      format: "a4",
  //    });

  //    const pageWidth = doc.internal.pageSize.getWidth(); // ~297mm
  //    const pageHeight = doc.internal.pageSize.getHeight() / 2; // half A4 height (~105mm)
  //    const padding = 5;

  //    // ------------------------- HEADER LOGO -------------------------
  //    const headerX = padding;
  //    const headerY = padding;

  //    if (data?.salefrom?.image) {
  //      try {
  //  const imagePath = settings?.saleProfileData?.image
  //     ? uRLs?.IMAGE_URL + "profile/" + settings?.saleProfileData?.image
  //     : "/assets/images/logo-light.png";
  //        const response = await fetch(imagePath);
  //        const blob = await response.blob();
  //        const base64 = await new Promise((resolve, reject) => {
  //          const reader = new FileReader();
  //          reader.onloadend = () => resolve(reader.result);
  //          reader.onerror = reject;
  //          reader.readAsDataURL(blob);
  //        });

  //        const { width: naturalWidth, height: naturalHeight } =
  //          await loadImageDimensions(base64);
  //        const maxWidth = 30;
  //        const maxHeight = 8;
  //        const ratio = Math.min(
  //          maxWidth / naturalWidth,
  //          maxHeight / naturalHeight
  //        );
  //        const imgWidth = naturalWidth * ratio;
  //        const imgHeight = naturalHeight * ratio;

  //        const ext = imagePath.split(".").pop().toLowerCase();
  //        const format = ext === "png" ? "PNG" : "JPEG";

  //        doc.addImage(base64, format, headerX, headerY, imgWidth, imgHeight);
  //      } catch (err) {
  //        console.warn("Image failed to load:", err);
  //      }
  //    }

  //    // ------------------------- INVOICE TITLE -------------------------
  //    const invoiceFontSize = 14;
  //    doc.setFont("Inter-Bold", "bold");
  //    doc.setFontSize(invoiceFontSize);

  //    const invoiceText = data.salemode
  //      ? formatTrackMode(data.salemode)
  //      : "INVOICE";
  //    const invoiceX = pageWidth - padding;
  //    const invoiceY = padding + invoiceFontSize * 0.55;
  //    const invoiceTextWidth = doc.getTextWidth(invoiceText);

  //    doc.text(invoiceText, invoiceX, invoiceY, { align: "right" });

  //    if (data.status === "CANCELLED") {
  //      doc.setFontSize(invoiceFontSize * 0.6);
  //      doc.setTextColor(220, 53, 69);
  //      doc.setFont("Inter-Bold", "bold");
  //      const cancelledX = invoiceX - invoiceTextWidth - 8;
  //      doc.text("CANCELLED", cancelledX, invoiceY, { align: "right" });
  //      doc.setTextColor(0, 0, 0);
  //      doc.setFontSize(invoiceFontSize);
  //    }

  //    // ------------------------- BILL INFO -------------------------
  //    doc.setFontSize(8);
  //    const invoiceNoLabel = "Bill No:";
  //    const invoiceNoValue = data.saleno || "-";
  //    const invoiceDateLabel = "Date:";
  //    const invoiceDateValue = data.saledate
  //      ? DateConverter.ISOToDisplayFormat(data.saledate).date
  //      : "-";

  //    const innerGap = 2;
  //    const gap = 5;
  //    const invoiceNoLabelWidth = doc.getTextWidth(invoiceNoLabel);
  //    const invoiceNoValueWidth = doc.getTextWidth(invoiceNoValue);
  //    const invoiceDateLabelWidth = doc.getTextWidth(invoiceDateLabel);
  //    const invoiceDateValueWidth = doc.getTextWidth(invoiceDateValue);

  //    const totalTextWidth =
  //      invoiceNoLabelWidth +
  //      innerGap +
  //      invoiceNoValueWidth +
  //      gap +
  //      invoiceDateLabelWidth +
  //      innerGap +
  //      invoiceDateValueWidth;

  //    const invoiceRowX = pageWidth - padding - totalTextWidth;
  //    const invoiceRowY = invoiceY + 8;

  //    // Middle line
  //    doc.setDrawColor(selectedTheme?.templateTheme?.primaryColor);
  //    doc.setLineWidth(2);
  //    doc.setLineCap("round");
  //    doc.line(padding, invoiceRowY, invoiceRowX - 5, invoiceRowY);

  //    doc.setFont("Inter-Bold", "bold");
  //    doc.text(invoiceNoLabel, invoiceRowX, invoiceRowY);
  //    doc.setFont("Inter-Regular", "normal");
  //    doc.text(
  //      invoiceNoValue,
  //      invoiceRowX + invoiceNoLabelWidth + innerGap,
  //      invoiceRowY
  //    );

  //    const dateX =
  //      invoiceRowX + invoiceNoLabelWidth + innerGap + invoiceNoValueWidth + gap;
  //    doc.setFont("Inter-Bold", "bold");
  //    doc.text(invoiceDateLabel, dateX, invoiceRowY);
  //    doc.setFont("Inter-Regular", "normal");
  //    doc.text(
  //      invoiceDateValue,
  //      dateX + invoiceDateLabelWidth + innerGap,
  //      invoiceRowY
  //    );

  //    // ------------------------- INVOICE FROM -------------------------
  //    const topY = headerY + padding;
  //    const bottomY = invoiceY;
  //    const middleY = topY + (bottomY - topY) / 2;

  //    const fromLines = [
  //      [
  //        data.salefrom?.title || "-",
  //        [
  //          data.salefrom?.addressline1,
  //          data.salefrom?.addressline2,
  //          data.salefrom?.district,
  //          data.salefrom?.country,
  //          data.salefrom?.pincode ? `- ${data.salefrom.pincode}` : "",
  //        ]
  //          .filter(Boolean)
  //          .join(", "),
  //      ]
  //        .filter(Boolean)
  //        .join(", "),
  //      [
  //        data.salefrom?.phone ? `Phone: ${data.salefrom.phone}` : "",
  //        data.salefrom?.email ? `Email: ${data.salefrom.email}` : "",
  //        data.salefrom?.state
  //          ? `State: ${data.salefrom.state} [Code: ${
  //              data.salefrom?.statecode || ""
  //            }]`
  //          : "",
  //      ]
  //        .filter(Boolean)
  //        .join("  |  "),
  //    ];

  //    const leftX = padding + 35;
  //    const rightX = pageWidth - padding - invoiceTextWidth - 10;
  //    const availableWidth = rightX - leftX;

  //    doc.setFont("Inter-Regular", "normal");
  //    doc.setFontSize(9);
  //    fromLines.forEach((line, i) => {
  //      doc.text(
  //        doc.splitTextToSize(line, availableWidth),
  //        leftX,
  //        middleY + i * 5
  //      );
  //    });

  //    let toY = middleY + fromLines.length * 10;

  //    // ------------------------- INVOICE TO -------------------------
  //    if (data.saleto?.name || data.saleto?.addressline1) {
  //      doc.setFont("Inter-Bold", "bold");
  //      doc.setFontSize(10);
  //      doc.text("Bill To:", padding, toY);
  //      toY += 5;

  //      const toLine = [
  //        data.saleto?.name || "-",
  //        [
  //          data.saleto?.addressline1,
  //          data.saleto?.addressline2,
  //          data.saleto?.district,
  //          data.saleto?.country,
  //          data.saleto?.pincode ? `- ${data.saleto.pincode}` : "",
  //        ]
  //          .filter(Boolean)
  //          .join(", "),
  //        data.saleto?.phone ? `Phone: ${data.saleto.phone}` : "",
  //        data.saleto?.email ? `Email: ${data.saleto.email}` : "",
  //        data.saleto?.state
  //          ? `State: ${data.saleto.state} [Code: ${
  //              data.saleto?.statecode || ""
  //            }]`
  //          : "",
  //      ]
  //        .filter(Boolean)
  //        .join(", ");

  //      doc.setFont("Inter-Regular", "normal");
  //      doc.setFontSize(9);
  //      doc.text(
  //        doc.splitTextToSize(toLine, pageWidth - padding * 2),
  //        padding,
  //        toY
  //      );
  //    }

  //    // ------------------------- PRODUCTS TABLE -------------------------
  //    const productBody = (data.saleitems || []).map((item, i) => {
  //      const desc = [
  //        `${item.title}`,
  //        ...(item.imode === "PRODUCT" && item.note ? [item.note] : []),
  //        ...(item.imode === "SERVICE" && item.description
  //          ? [item.description]
  //          : []),
  //      ].join("\n");

  //      return [
  //        i + 1,
  //        desc,
  //        `₹${CurrencyConverter.toCurrency(item.soldprice || 0, "INR")}`,
  //        item.quantity || 1,
  //        `₹${CurrencyConverter.toCurrency(item.lineTotalSoldPrice || 0, "INR")}`,
  //      ];
  //    });

  //    // Add total row inside table
  //    productBody.push([
  //      {
  //        content: "",
  //        colSpan: 2,
  //        styles: { fontStyle: "bold", font: "Inter-Bold" },
  //      },
  //      {
  //        content: "Total",
  //        styles: { halign: "right", font: "Inter-Bold", fontStyle: "bold" },
  //      },
  //      {
  //        content: data.totalqty || "-",
  //        styles: { font: "Inter-Bold", fontStyle: "bold" },
  //      },
  //      {
  //        content: `₹${CurrencyConverter.toCurrency(
  //          data.grandtotal || 0,
  //          "INR"
  //        )}`,
  //        styles: { font: "Inter-Bold", fontStyle: "bold" },
  //      },
  //    ]);

  //    const commonTableWidth = pageWidth - padding * 2;

  //    autoTable(doc, {
  //      startY: toY + 10,
  //      head: [["S.No", "Description", "Rate", "Qty", "Total"]],
  //      body: productBody,
  //      margin: { left: padding, right: padding },
  //      tableWidth: commonTableWidth,
  //      pageBreak: "avoid",
  //      styles: {
  //        font: "Inter-Regular",
  //        fontSize: 8,
  //        cellPadding: { top: 1, right: 2, bottom: 1, left: 2 },
  //        lineColor: selectedTheme?.templateTheme?.borderColor,
  //        lineWidth: 0.2,
  //        valign: "middle",
  //      },
  //      headStyles: {
  //        fillColor: selectedTheme?.templateTheme?.primaryColor,
  //        textColor: selectedTheme?.templateTheme?.foregroundColor,
  //        font: "Inter-Bold",
  //        fontStyle: "bold",
  //        fontSize: 8,
  //        halign: "center",
  //        valign: "middle",
  //      },
  //      columnStyles: {
  //        0: { cellWidth: commonTableWidth * 0.08, halign: "center" },
  //        1: { cellWidth: commonTableWidth * 0.5, halign: "left" },
  //        2: { cellWidth: commonTableWidth * 0.15, halign: "right" },
  //        3: { cellWidth: commonTableWidth * 0.1, halign: "center" },
  //        4: { cellWidth: commonTableWidth * 0.17, halign: "right" },
  //      },
  //      theme: "grid",
  //    });

  //    // ------------------------- TOTAL AMOUNT IN WORDS -------------------------
  //    const totalY = doc.lastAutoTable.finalY;

  //    const summaryBody = [
  //      [
  //        {
  //          content: "Total Amount In Words",
  //          colSpan: 3,
  //          styles: {
  //            fontStyle: "bold",
  //            font: "Inter-Bold",
  //            fontSize: 9,
  //            valign: "middle",
  //            halign: "left",
  //            cellPadding: 1.5,
  //            cellWidth: "wrap",
  //          },
  //        },
  //      ],
  //      [
  //        {
  //          content: data.amountinwords || "",
  //          colSpan: 3,
  //          styles: {
  //            halign: "center",
  //            valign: "middle",
  //            fontSize: 9,
  //            cellPadding: 2,
  //            cellWidth: "wrap",
  //          },
  //        },
  //      ],
  //      [
  //        {
  //          content: "Total",
  //          colSpan: 2,
  //          styles: { halign: "right", fontSize: 9 },
  //        },
  //        {
  //          content: `₹${CurrencyConverter.toCurrency(
  //            data.totalsoldprice || 0,
  //            "INR"
  //          )}`,
  //          styles: { halign: "center", valign: "middle", fontSize: 9 },
  //        },
  //      ],
  //      [
  //        {
  //          content: "Grand Total (Rounded)",
  //          colSpan: 2,
  //          styles: {
  //            font: "Inter-Bold",
  //            fontStyle: "bold",
  //            halign: "right",
  //            fontSize: 9,
  //          },
  //        },
  //        {
  //          content: `₹${CurrencyConverter.toCurrency(
  //            data.grandtotal || 0,
  //            "INR"
  //          )}`,
  //          styles: {
  //            halign: "center",
  //            valign: "middle",
  //            fontStyle: "bold",
  //            font: "Inter-Bold",
  //            fontSize: 10,
  //          },
  //        },
  //      ],
  //    ];

  //    autoTable(doc, {
  //      startY: totalY,
  //      body: summaryBody,
  //      pageBreak: "avoid",
  //      margin: { left: padding, right: padding },
  //      tableWidth: commonTableWidth,
  //      styles: {
  //        font: "Inter-Regular",
  //        fontSize: 8.5,
  //        cellPadding: 3,
  //        lineColor: selectedTheme?.templateTheme?.borderColor,
  //        lineWidth: 0.2,
  //        textColor: selectedTheme?.templateTheme?.foregroundColor,
  //        fillColor: selectedTheme?.templateTheme?.primaryColor,
  //        halign: "middle",
  //      },
  //      columnStyles: {
  //        0: { cellWidth: commonTableWidth * 0.6, halign: "left" },
  //        1: { cellWidth: commonTableWidth * 0.2, halign: "right" },
  //        2: { cellWidth: commonTableWidth * 0.2, halign: "center" },
  //      },
  //      didParseCell: function (data) {
  //        const lastRowIndex = summaryBody?.length - 1;
  //        if (data.section === "body") {
  //          if (data.row.index === lastRowIndex) {
  //            // data.cell.styles.fillColor = "#f4f4f6";
  //            // data.cell.styles.textColor = [0, 0, 0];
  //            data.cell.styles.font = "Inter-Bold";
  //            data.cell.styles.fontStyle = "bold";
  //          } else {
  //            data.cell.styles.fillColor = "#ffffff";
  //            data.cell.styles.textColor = [0, 0, 0];
  //            data.cell.styles.font = "Inter-Regular";
  //            data.cell.styles.fontStyle = "normal";
  //          }
  //        }
  //      },
  //      theme: "grid",
  //    });

  //    // ------------------------- FOOTER -------------------------
  //    const afterSummaryY = doc.lastAutoTable.finalY;
  //    const pageHeight2 = doc.internal.pageSize.getHeight();
  //    const marginBottom2 = 20;
  //    const declarationHeight = 45;
  //    let finalY;
  //    if (afterSummaryY + declarationHeight + marginBottom2 > pageHeight2) {
  //      doc.addPage();
  //      finalY = 10;
  //    } else {
  //      finalY = afterSummaryY;
  //    }
  //    let currentY = finalY + 10;

  //    if (parseFloat(data?.totaldiscount) > 0) {
  //      doc.setFont("Inter-Bold", "bold");
  //      doc.setFontSize(10);
  //      doc.text(
  //        `Your Total Discount : ₹${CurrencyConverter.toCurrency(
  //          data?.totaldiscount || 0,
  //          "INR"
  //        )}`,
  //        pageWidth / 2,
  //        currentY,
  //        { align: "center" }
  //      );

  //      currentY += 2; // ONLY if discount exists
  //    }

  //    // ---------------- PAYMENT MODE TABLE (LEFT – 2 INCH STYLE) ----------------

  //    const paymentRows = [];

  //    const cashPaid = (data?.cashamount || 0) - (data?.cashchange || 0);

  //    const cardPaid = (data?.cardamount || 0) - (data?.cardchange || 0);

  //    const onlinePaid = (data?.onlineamount || 0) - (data?.onlinechange || 0);

  //    const upiPaid = (data?.upiamount || 0) - (data?.upichange || 0);

  //    const balanceDue =
  //      (data?.paylateramount || 0) - (data?.paylaterchange || 0);

  //    // condition based rows
  //    if (cashPaid > 0) {
  //      paymentRows.push([
  //        "Cash",
  //        `₹${CurrencyConverter.toCurrency(cashPaid, "INR")}`,
  //      ]);
  //    }

  //    if (cardPaid > 0) {
  //      paymentRows.push([
  //        "Card",
  //        `₹${CurrencyConverter.toCurrency(cardPaid, "INR")}`,
  //      ]);
  //    }

  //    if (onlinePaid > 0) {
  //      paymentRows.push([
  //        "Online Amount",
  //        `₹${CurrencyConverter.toCurrency(onlinePaid, "INR")}`,
  //      ]);
  //    }

  //    if (upiPaid > 0) {
  //      paymentRows.push([
  //        "UPI",
  //        `₹${CurrencyConverter.toCurrency(upiPaid, "INR")}`,
  //      ]);
  //    }

  //    if (balanceDue > 0) {
  //      paymentRows.push([
  //        "Balance Due",
  //        `₹${CurrencyConverter.toCurrency(balanceDue, "INR")}`,
  //      ]);
  //    }

  //    // draw table ONLY if rows exist
  //    if (paymentRows?.length > 0) {
  //      autoTable(doc, {
  //        startY: currentY,
  //        head: [["Payment Mode", ""]],
  //        body: paymentRows,
  //        margin: { left: 6 },
  //        tableWidth: 70,
  //        styles: {
  //          font: "Inter-Regular",
  //          fontSize: 8,
  //          cellPadding: 2,
  //          lineColor: selectedTheme?.templateTheme?.borderColor,
  //          lineWidth: 0.2,
  //          textColor: "#000",
  //        },
  //        headStyles: {
  //          fillColor: selectedTheme?.templateTheme?.primaryColor,
  //          textColor: selectedTheme?.templateTheme?.foregroundColor,
  //          font: "Inter-Bold",
  //          fontStyle: "bold",
  //          halign: "center",
  //        },
  //        columnStyles: {
  //          0: { cellWidth: 40, halign: "left" },
  //          1: { cellWidth: 30, halign: "right" },
  //        },
  //        theme: "grid",
  //      });

  //      currentY = doc.lastAutoTable.finalY + 6;
  //    }

  //    doc.setFont("Inter-Bold", "bold");
  //    doc.setFontSize(10);
  //    doc.text("***** Thank You! Visit Us Again *****", pageWidth / 2, currentY, {
  //      align: "center",
  //    });
  //    if (storeSettings?.negobillBranding) {
  //      currentY += 5;
  //      doc.setFont("Inter-Bold", "bold");
  //      doc.setFontSize(10);
  //      doc.text("Powerd By", pageWidth / 2, currentY, { align: "center" });
  //      currentY += 5;
  //      doc.setFont("Inter-Bold", "bold");
  //      doc.setFontSize(10);
  //      doc.text("www.NegoBill.com", pageWidth / 2, currentY, {
  //        align: "center",
  //      });
  //    }
  //    currentY += 8;

  //    if (terms?.length > 0) {
  //      doc.setFont("Inter-Bold", "bold");
  //      doc.setFontSize(9);
  //      doc.text("Terms & Conditions", 10, currentY);

  //      doc.setFont("Inter-Regular", "normal");
  //      doc.setFontSize(7);
  //      doc.text(terms, 13, currentY + 4);
  //    }
  //    const rightXs = pageWidth - padding;

  //    const boxTopY = currentY + 3;
  //    // const boxTopY = footerY + 7;
  //    const boxHeight = 20;
  //    const boxLeftX = padding;
  //    const boxRightX = pageWidth - padding;
  //    const boxWidth = boxRightX - boxLeftX;
  //    const boxMidX = boxLeftX + boxWidth / 2;
  //    doc.setFontSize(8);
  //    doc.setFont("Inter-Regular", "normal");
  //    const titleWidths = doc.getTextWidth("Issued By,Signature");
  //    const titleText = String(data?.salefrom?.title || "");
  //    doc.text("Issued By,Signature", rightXs, boxTopY, { align: "right" });
  //    doc.setFontSize(9);
  //    doc.setFont("Inter-Bold", "bold");
  //    doc.text(titleText, rightXs, boxTopY + 4, { align: "right" });
  //    const signimg = uRLs.IMAGE_URL + storeSettings?.invoiceSettings?.signature;
  //    if (storeSettings?.invoiceSettings?.signature) {
  //      try {
  //        // Convert image URL to base64
  //        const response = await fetch(signimg);
  //        const blob = await response.blob();
  //        const base64 = await new Promise((resolve, reject) => {
  //          const reader = new FileReader();
  //          reader.onloadend = () => resolve(reader.result);
  //          reader.onerror = reject;
  //          reader.readAsDataURL(blob);
  //        });

  //        // Load original dimensions
  //        const { width: naturalWidth, height: naturalHeight } =
  //          await loadImageDimensions(base64);

  //        // Resize logic
  //        const maxWidth = 50;
  //        const maxHeight = 10;
  //        let imgWidth = naturalWidth;
  //        let imgHeight = naturalHeight;
  //        const widthRatio = maxWidth / imgWidth;
  //        const heightRatio = maxHeight / imgHeight;
  //        const ratio = Math.min(widthRatio, heightRatio);
  //        imgWidth *= ratio;
  //        imgHeight *= ratio;

  //        const getImageFormat = (path) => {
  //          const ext = path.split(".").pop().toLowerCase();
  //          if (ext === "jpg" || ext === "jpeg") return "JPEG";
  //          if (ext === "png") return "PNG";
  //          return "JPEG";
  //        };
  //        const format = getImageFormat(signimg);
  //        const imgX = rightXs - imgWidth;
  //        doc.addImage(base64, format, imgX, boxTopY + 6, imgWidth, imgHeight);
  //      } catch (err) {
  //        console.warn("Image failed to load:", err);
  //      }
  //    }
  //    // doc.setFont("Inter-Bold", "bold");
  //    // doc.setFontSize(9);
  //    // doc.text("www.NegoBill.com", pageWidth / 2, footerY, { align: "center" });

  //    setDownload(false);
  //    // setPrint(false);
  //    return doc;
  //  };
  const generateBillHalfA4PDF = async () => {
    const doc = new jsPDF("p", "mm", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    const padding = 5;
    const headerX = 2;
    const headerY = 2;
    const HALF_PAGE_HEIGHT = 140;
    const imagePath = settings?.saleProfileData?.image
      ? uRLs?.IMAGE_URL + "profile/" + settings?.saleProfileData?.image
      : "/assets/images/logo-light.png";
    if (data?.salefrom?.image) {
      try {
        // Convert image URL to base64
        const response = await fetch(imagePath);
        const blob = await response.blob();
        const base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });

        // Load original dimensions
        const { width: naturalWidth, height: naturalHeight } =
          await loadImageDimensions(base64);

        // Resize logic
        const maxWidth = 30;
        const maxHeight = 8;
        let imgWidth = naturalWidth;
        let imgHeight = naturalHeight;
        const widthRatio = maxWidth / imgWidth;
        const heightRatio = maxHeight / imgHeight;
        const ratio = Math.min(widthRatio, heightRatio);
        imgWidth *= ratio;
        imgHeight *= ratio;

        // Determine format
        const getImageFormat = (path) => {
          const ext = path.split(".").pop().toLowerCase();
          if (ext === "jpg" || ext === "jpeg") return "JPEG";
          if (ext === "png") return "PNG";
          return "JPEG";
        };
        const format = getImageFormat(imagePath);

        // Add image to PDF
        doc.addImage(base64, format, padding, padding, imgWidth, imgHeight);
      } catch (err) {
        console.warn("Image failed to load:", err);
      }
    }

    const invoiceFontSize = 9;
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(invoiceFontSize);
    // Estimate vertical alignment by adjusting for font size
    const textHeightOffset = invoiceFontSize * 0.55;
    const invoiceTextY = headerY + textHeightOffset;
    const invoiceX = pageWidth - padding;
    const invoiceText = data.salemode && formatTrackMode(data.salemode);
    const invoiceTextWidth = doc.getTextWidth(invoiceText);
    doc.text(invoiceText, invoiceX, invoiceTextY, { align: "right" });
    // If cancelled, show "CANCELLED" immediately to the right of "INVOICE"
    if (data?.status === "CANCELLED") {
      const cancelledFontSize = invoiceFontSize * 0.6;
      doc.setFontSize(cancelledFontSize);
      doc.setTextColor(220, 53, 69); // Bootstrap danger red
      doc.setFont("Inter-Bold", "bold");
      // Position CANCELLED right after INVOICE
      const cancelledX = invoiceX - invoiceTextWidth - 8; // 8 is spacing between words
      doc.text("CANCELLED", cancelledX, invoiceTextY, { align: "right" });
      // Reset styles
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(invoiceFontSize);
    }

    // Prepare font size for labels and values
    doc.setFontSize(7);
    const invoiceNoLabel = "Bill No:";
    const invoiceNoValue = data.saleno;
    const invoiceDateLabel = "Date:";
    const invoiceDateValue = DateConverter.ISOToDisplayFormat(
      data.saledate
    ).date;
    // Measure total widths
    const invoiceNoLabelWidth = doc.getTextWidth(invoiceNoLabel);
    const invoiceNoValueWidth = doc.getTextWidth(invoiceNoValue);
    const invoiceDateLabelWidth = doc.getTextWidth(invoiceDateLabel);
    const invoiceDateValueWidth = doc.getTextWidth(invoiceDateValue);
    const gap = 5;
    const innerGap = 2;
    const invoiceRowY = 15;
    const totalTextWidth =
      invoiceNoLabelWidth +
      innerGap +
      invoiceNoValueWidth +
      gap +
      invoiceDateLabelWidth +
      innerGap +
      invoiceDateValueWidth;
    const invoiceRowX = pageWidth - padding - totalTextWidth;
    const lineStartX = padding;
    const lineEndX = invoiceRowX - 5;
    const lineY = invoiceRowY;
    // Middle line
    doc.setDrawColor(selectedTheme?.templateTheme?.primaryColor);
    doc.setLineWidth(2);
    doc.setLineCap("round");
    doc.line(lineStartX, lineY, lineEndX, lineY);

    doc.setFont("Inter-Bold", "bold");
    doc.text(invoiceNoLabel, invoiceRowX, invoiceRowY);
    doc.setFont("Inter-Regular", "normal");
    doc.text(
      invoiceNoValue,
      invoiceRowX + invoiceNoLabelWidth + innerGap,
      invoiceRowY
    );
    const dateX =
      invoiceRowX + invoiceNoLabelWidth + innerGap + invoiceNoValueWidth + gap;

    doc.setFont("Inter-Bold", "bold");
    doc.text(invoiceDateLabel, dateX, invoiceRowY);

    doc.setFont("Inter-Regular", "normal");
    doc.text(
      invoiceDateValue,
      dateX + invoiceDateLabelWidth + innerGap,
      invoiceRowY
    );
    // --- Invoice From (between logo & title, in 2 lines) ---
    const topY = headerY + padding; // logo top
    const bottomY = invoiceTextY; // invoice title baseline
    const middleY = topY + (bottomY - topY) / 2; // midpoint

    // Line 1: Company + Address
    const line1 = [
      data.salefrom?.title || "-",
      [
        data.salefrom?.addressline1,
        data.salefrom?.addressline2,
        data.salefrom?.district,
        data.salefrom?.state,
        //  data.salefrom?.country,
        data.salefrom?.pincode ? `- ${data.salefrom.pincode}` : "",
        data.salefrom?.phone ? `Phone: ${data.salefrom.phone}` : "",
        data.salefrom?.email ? `Email: ${data.salefrom.email}` : "",
        //  data.salefrom?.gstnumber ? `GST: ${data.salefrom.gstnumber}` : "",
      ]
        .filter(Boolean)
        .join(", "),
    ]
      .filter(Boolean)
      .join(", ");

    const fromDetails = [line1];

    const leftX = padding + 35;
    const rightX = pageWidth - padding - invoiceTextWidth - 10;
    const availableWidth = rightX - leftX - 5;
    let currentY = middleY;
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(7);
    fromDetails.forEach((line) => {
      const wrappedLine = doc.splitTextToSize(line, availableWidth);
      doc.text(wrappedLine, leftX, currentY, { align: "left" });
      currentY += wrappedLine.length * 4;
    });

    let toY = invoiceRowY + 6;

    const hasSaleToData =
      data.saleto &&
      (data.saleto.name ||
        data.saleto.addressline1 ||
        data.saleto.addressline2 ||
        data.saleto.district ||
        data.saleto.country ||
        data.saleto.pincode ||
        data.saleto.phone ||
        data.saleto.email ||
        data.saleto.gstnumber ||
        data.saleto.state ||
        data.saleto.statecode ||
        data.saleto.referid);

    if (hasSaleToData) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8.5);
      doc.text("Invoice To:", padding, toY);

      toY += 3;

      const toDetailsLine = [
        data.saleto?.name || "-",
        [
          data.saleto?.addressline1,
          data.saleto?.addressline2,
          data.saleto?.district,
          data.saleto?.statecode,
          //  data.saleto?.country,
          data.saleto?.pincode ? `- ${data.saleto.pincode}` : "",
        ]
          .filter(Boolean)
          .join(", "),
        data.saleto?.phone ? `Phone: ${data.saleto.phone}` : "",
        data.saleto?.email ? `Email: ${data.saleto.email}` : "",
        //  data.saleto?.gstnumber ? `GST: ${data.saleto.gstnumber}` : "",

        //  data.saleto?.referid ? `Reference No: ${data.saleto.referid}` : "",
      ]
        .filter(Boolean)
        .join(", ");

      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(7);
      const wrappedAddress = doc.splitTextToSize(
        toDetailsLine,
        pageWidth - padding * 2
      );

      // 2. Draw the wrapped text
      doc.text(wrappedAddress, padding, toY);

      // 3. IMPORTANT: Update toY based on the number of wrapped lines
      // This ensures the table starts BELOW the address
      toY += wrappedAddress.length * 3;
    }

    // 3. Product Table
    const productBody = data.saleitems?.map((item, i) => {
      const qty = item.quantity || 1;
      const rate = CurrencyConverter.toCurrency(item.soldprice || 0, "INR");
      const total = CurrencyConverter.toCurrency(
        item.lineTotalSoldPrice || 0,
        "INR"
      );
      const gross = CurrencyConverter.toCurrency(
        item.lineTotalSoldPrice || 0,
        "INR"
      );
      const taxable = CurrencyConverter.toCurrency(
        item.lineTotalBasePrice || 0,
        "INR"
      );
      const gstAmt = CurrencyConverter.toCurrency(
        item.lineTotalTaxAmount || 0,
        "INR"
      );

      const desc = [
        `${item.title}`,
        ...(item.imode === "PRODUCT" && item.note ? [item.note] : []),
        ...(item.imode === "SERVICE" && item.description
          ? [item.description]
          : []),
        ...(item.hsnsac ? [`HSN/SAC : ${item.hsnsac}`] : []),
        ...(item.discount > 0
          ? [`MRP     : ₹${CurrencyConverter.toCurrency(item.mrp || 0, "INR")}`]
          : []),
        ...(item.discount > 0
          ? [
              `Discount: - ₹${CurrencyConverter.toCurrency(
                item.discount,
                "INR"
              )}`,
            ]
          : []),
        //  `GST     : ${item.taxpercentage}%`,
      ].join("\n");

      return [
        i + 1,
        desc,
        `₹${rate}`,
        qty,
        `₹${gross}`,
        `₹${taxable}`,
        `₹${gstAmt}`,
        `₹${total}`,
      ];
    });

    // Add total row INSIDE the same table
    productBody.push([
      {
        content: "",
        colSpan: 2,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: "Total",
        styles: { halign: "right", fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: data.totalqty,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: `₹${CurrencyConverter.toCurrency(
          data.totalsoldprice || 0,
          "INR"
        )}`,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: `₹${CurrencyConverter.toCurrency(
          data.totalbaseprice || 0,
          "INR"
        )}`,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: `₹${CurrencyConverter.toCurrency(
          data.totaltaxamount || 0,
          "INR"
        )}`,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: `₹${CurrencyConverter.toCurrency(
          data.grandtotal || 0,
          "INR"
        )}`,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
    ]);

    const commonTableWidth = doc.internal.pageSize.getWidth() - padding * 2;

    autoTable(doc, {
      startY: toY,
      head: [["S.No", "Description", "Rate", "Qty", "Total"]],
      body: productBody,
      margin: {
        left: padding,
        right: padding,
        bottom: pageH - HALF_PAGE_HEIGHT + padding,
      },
      tableWidth: commonTableWidth,
      pageBreak: "avoid",
      styles: {
        font: "Inter-Regular",
        fontSize: 7,
        cellPadding: { top: 1, right: 2, bottom: 1, left: 2 },
        lineColor: selectedTheme?.templateTheme?.borderColor,
        lineWidth: 0.2,
        valign: "middle",
      },
      headStyles: {
        fillColor: selectedTheme?.templateTheme?.primaryColor,
        textColor: selectedTheme?.templateTheme?.foregroundColor,
        font: "Inter-Bold",
        fontStyle: "bold",
        fontSize: 8,
        halign: "center",
        valign: "middle",
      },
      columnStyles: {
        0: { cellWidth: commonTableWidth * 0.08, halign: "center" },
        1: { cellWidth: commonTableWidth * 0.5, halign: "left" },
        2: { cellWidth: commonTableWidth * 0.15, halign: "right" },
        3: { cellWidth: commonTableWidth * 0.1, halign: "center" },
        4: { cellWidth: commonTableWidth * 0.17, halign: "right" },
      },
      theme: "grid",
    });

    // ------------------------- TOTAL AMOUNT IN WORDS -------------------------
    const totalY = doc.lastAutoTable.finalY;

    const summaryBody = [
      [
        {
          content: `Total Amount In Words : ${data.amountinwords || ""}`,
          colSpan: 3,
          styles: {
            fontStyle: "bold",
            font: "Inter-Bold",
            fontSize: 8,
            valign: "middle",
            halign: "left",
            cellPadding: 1.5,
            cellWidth: "wrap",
          },
        },
      ],
      //  [
      //    {
      //      content: data.amountinwords || "",
      //      colSpan: 2,
      //      styles: {
      //        halign: "center",
      //        valign: "middle",
      //        fontSize: 8,
      //        cellPadding: 2,
      //        cellWidth: "wrap",
      //      },
      //    },
      //  ],
      [
        {
          content: "Total",
          colSpan: 2,
          styles: { halign: "right", fontSize: 9 },
        },
        {
          content: `₹${CurrencyConverter.toCurrency(
            data.totalsoldprice || 0,
            "INR"
          )}`,
          styles: { halign: "center", valign: "middle", fontSize: 9 },
        },
      ],
      [
        {
          content: "Grand Total (Rounded)",
          colSpan: 2,
          styles: {
            font: "Inter-Bold",
            fontStyle: "bold",
            halign: "right",
            fontSize: 9,
          },
        },
        {
          content: `₹${CurrencyConverter.toCurrency(
            data.grandtotal || 0,
            "INR"
          )}`,
          styles: {
            halign: "center",
            valign: "middle",
            fontStyle: "bold",
            font: "Inter-Bold",
            fontSize: 10,
          },
        },
      ],
    ];

    autoTable(doc, {
      startY: totalY,
      body: summaryBody,
      pageBreak: "avoid",
      margin: { left: padding, right: padding },
      tableWidth: commonTableWidth,
      styles: {
        font: "Inter-Regular",
        fontSize: 8,
        cellPadding: 1.3,
        lineColor: selectedTheme?.templateTheme?.borderColor,
        lineWidth: 0.2,
        textColor: selectedTheme?.templateTheme?.foregroundColor,
        fillColor: selectedTheme?.templateTheme?.primaryColor,
        halign: "middle",
      },
      columnStyles: {
        0: { cellWidth: commonTableWidth * 0.6, halign: "left" },
        1: { cellWidth: commonTableWidth * 0.2, halign: "right" },
        2: { cellWidth: commonTableWidth * 0.2, halign: "center" },
      },
      didParseCell: function (data) {
        const lastRowIndex = summaryBody?.length - 1;
        if (data.section === "body") {
          if (data.row.index === lastRowIndex) {
            // data.cell.styles.fillColor = "#f4f4f6";
            // data.cell.styles.textColor = [0, 0, 0];
            data.cell.styles.font = "Inter-Bold";
            data.cell.styles.fontStyle = "bold";
          } else {
            data.cell.styles.fillColor = "#ffffff";
            data.cell.styles.textColor = [0, 0, 0];
            data.cell.styles.font = "Inter-Regular";
            data.cell.styles.fontStyle = "normal";
          }
        }
      },
      theme: "grid",
    });

    // ------------------------- FOOTER -------------------------
    const afterSummaryY = doc.lastAutoTable.finalY;
    const pageHeight2 = doc.internal.pageSize.getHeight();
    const marginBottom2 = 20;
    const declarationHeight = 45;
    let finalY;
    if (afterSummaryY + declarationHeight + marginBottom2 > pageHeight2) {
      doc.addPage();
      finalY = 10;
    } else {
      finalY = afterSummaryY;
    }
    currentY = finalY + 4;

    if (parseFloat(data?.totaldiscount) > 0) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(7);
      doc.text(
        `Your Total Discount : ₹${CurrencyConverter.toCurrency(
          data?.totaldiscount || 0,
          "INR"
        )}`,
        pageWidth / 2,
        currentY,
        { align: "center" }
      );

      currentY += 2; // ONLY if discount exists
    }

    const paymentRows = [];

    const cashPaid = (data?.cashamount || 0) - (data?.cashchange || 0);

    const cardPaid = (data?.cardamount || 0) - (data?.cardchange || 0);

    const onlinePaid = (data?.onlineamount || 0) - (data?.onlinechange || 0);

    const upiPaid = (data?.upiamount || 0) - (data?.upichange || 0);

    const balanceDue =
      (data?.paylateramount || 0) - (data?.paylaterchange || 0);

    if (cashPaid > 0) {
      paymentRows.push([
        "Cash",
        `₹${CurrencyConverter.toCurrency(cashPaid, "INR")}`,
      ]);
    }

    if (cardPaid > 0) {
      paymentRows.push([
        "Card",
        `₹${CurrencyConverter.toCurrency(cardPaid, "INR")}`,
      ]);
    }

    if (onlinePaid > 0) {
      paymentRows.push([
        "Online Amount",
        `₹${CurrencyConverter.toCurrency(onlinePaid, "INR")}`,
      ]);
    }

    if (upiPaid > 0) {
      paymentRows.push([
        "UPI",
        `₹${CurrencyConverter.toCurrency(upiPaid, "INR")}`,
      ]);
    }

    if (balanceDue > 0) {
      paymentRows.push([
        "Balance Due",
        `₹${CurrencyConverter.toCurrency(balanceDue, "INR")}`,
      ]);
    }

    // draw table ONLY if rows exist
    //  if (paymentRows?.length > 0) {
    //    autoTable(doc, {
    //      startY: currentY,
    //      head: [["Payment Mode", ""]],
    //      body: paymentRows,
    //      margin: { left: 6 },
    //      tableWidth: 70,
    //      styles: {
    //        font: "Inter-Regular",
    //        fontSize: 8,
    //        cellPadding: 2,
    //        lineColor: selectedTheme?.templateTheme?.borderColor,
    //        lineWidth: 0.2,
    //        textColor: "#000",
    //      },
    //      headStyles: {
    //        fillColor: selectedTheme?.templateTheme?.primaryColor,
    //        textColor: selectedTheme?.templateTheme?.foregroundColor,
    //        font: "Inter-Bold",
    //        fontStyle: "bold",
    //        halign: "center",
    //      },
    //      columnStyles: {
    //        0: { cellWidth: 40, halign: "left" },
    //        1: { cellWidth: 30, halign: "right" },
    //      },
    //      theme: "grid",
    //    });

    //    currentY = doc.lastAutoTable.finalY + 6;
    //  }
    //  currentY+=2;
    //      doc.setFont("Inter-Bold", "bold");
    //      doc.setFontSize(8);
    //      doc.text("***** Thank You! Visit Us Again *****", pageWidth / 2, currentY, {
    //        align: "center",
    //      });
    if (storeSettings?.negobillBranding) {
      currentY += 1;
      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(6);
      doc.text("Powerd By", pageWidth / 2, currentY, { align: "center" });
      currentY += 3;
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(6);
      doc.text("www.NegoBill.com", pageWidth / 2, currentY, {
        align: "center",
      });
    }
    //  currentY += 2;
    const rightXs = pageWidth - padding;

    const boxTopY = currentY - padding;
    // const boxTopY = footerY + 7;
    const boxHeight = 20;
    const boxLeftX = padding;
    const boxRightX = pageWidth - padding;
    const boxWidth = boxRightX - boxLeftX;
    const boxMidX = boxLeftX + boxWidth / 2;
    doc.setFontSize(7);
    doc.setFont("Inter-Regular", "normal");
    //  const titleWidths = doc.getTextWidth("Issued By,Signature");
    //  const titleText = String(data?.salefrom?.title || "");
    doc.text("Issued By,Signature", rightXs, boxTopY, { align: "right" });

    const signimg = uRLs.IMAGE_URL + storeSettings?.invoiceSettings?.signature;
    if (storeSettings?.invoiceSettings?.signature) {
      try {
        // Convert image URL to base64
        const response = await fetch(signimg);
        const blob = await response.blob();
        const base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });

        // Load original dimensions
        const { width: naturalWidth, height: naturalHeight } =
          await loadImageDimensions(base64);

        // Resize logic
        const maxWidth = 50;
        const maxHeight = 10;
        let imgWidth = naturalWidth;
        let imgHeight = naturalHeight;
        const widthRatio = maxWidth / imgWidth;
        const heightRatio = maxHeight / imgHeight;
        const ratio = Math.min(widthRatio, heightRatio);
        imgWidth *= ratio;
        imgHeight *= ratio;

        const getImageFormat = (path) => {
          const ext = path.split(".").pop().toLowerCase();
          if (ext === "jpg" || ext === "jpeg") return "JPEG";
          if (ext === "png") return "PNG";
          return "JPEG";
        };
        const format = getImageFormat(signimg);
        const imgX = rightXs - imgWidth + padding;
        doc.addImage(base64, format, imgX, boxTopY + 1, imgWidth, imgHeight);
      } catch (err) {
        console.warn("Image failed to load:", err);
      }
    }
    // doc.setFont("Inter-Bold", "bold");
    // doc.setFontSize(9);
    // doc.text("www.NegoBill.com", pageWidth / 2, footerY, { align: "center" });

    // setPrint(false);
    return doc;
  };
  const handleDownload = async (data) => {
    setDownload(true);
    const { salemode, saleno } = data || {};

    let doc;

    if (salemode?.toUpperCase() === "BILL") {
      doc = await generateBillHalfA4PDF();
    } else {
      doc = await generateinvoiceHalfA4PDF();
    }

    const filenamePrefix = formatTrackMode(salemode)?.replace(/\s+/g, "_");
    doc.save(`${filenamePrefix}_${saleno}.pdf`);
  };

  const handlePrint = async (data, overrideSize = null) => {
    setPrint(true);
    try {
      if (!checkNetwork()) return;

      const paperSize = overrideSize || selectedSize;
      const upperMode = data?.salemode?.toUpperCase();
      let doc;

      if (paperSize === "BILL") {
        doc = await generateBillHalfA4PDF();
      } else {
        doc = await generateinvoiceHalfA4PDF();
      }

      const blob = doc.output("blob");
      const blobUrl = URL.createObjectURL(blob);

      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      iframe.src = blobUrl;
      document.body.appendChild(iframe);

      iframe.onload = () => {
        const printWindow = iframe.contentWindow;

        const cleanup = () => {
          // Remove iframe safely
          if (iframe && iframe.parentNode) {
            iframe.parentNode.removeChild(iframe);
          }

          // Remove listeners
          window.removeEventListener("afterprint", cleanup);
          printWindow.matchMedia("(print)").removeListener(handlePrintState);
        };

        const handlePrintState = (mql) => {
          // WHEN PRINT PREVIEW CLOSES (printed OR canceled)
          if (!mql.matches) {
            setTimeout(cleanup, 50); // small delay makes Chrome stable
          }
        };

        // Watch print state
        printWindow.matchMedia("(print)").addListener(handlePrintState);

        // Also catch Chrome's afterprint
        window.addEventListener("afterprint", cleanup);
        setPrint(false);
        setTimeout(() => {
          if (window.bootstrap && window.bootstrap.Dropdown) {
            const dropdownElementList = [].slice.call(
              document.querySelectorAll(".dropdown-toggle")
            );
            dropdownElementList.map(function (dropdownToggleEl) {
              return new window.bootstrap.Dropdown(dropdownToggleEl);
            });
          }
        }, 100);
        // Trigger printing
        setTimeout(() => {
          printWindow.focus();
          printWindow.print();
        }, 300);
      };
    } catch (error) {
      setPrint(false);
      handleError(error, showAlert);
      return false;
    }
    // finally {
    //   setPrint(false);
    // }
  };

  useEffect(() => {
    setData(isViewData);
  }, [isViewData]);

  useEffect(() => {
    jsPDF.API.events.push([
      "addFonts",
      function () {
        this.addFileToVFS("Inter_24pt-Regular-normal.ttf", InterRegular);
        this.addFileToVFS("Inter_24pt-Bold-normal.ttf", InterBold);
        this.addFont(
          "Inter_24pt-Regular-normal.ttf",
          "Inter-Regular",
          "normal"
        );
        this.addFont("Inter_24pt-Bold-normal.ttf", "Inter-Bold", "bold");
      },
    ]);
  }, []);

  const formatCurrency2 = (value) => {
    const amount = CurrencyConverter.toCurrency(value, "INR");
    const formatted = Math.abs(amount).toLocaleString("en-IN", {
      minimumFractionDigits: 0, // Don't force .00
      maximumFractionDigits: 2, // Show up to 2 decimals if they exist (like .78)
    });

    return value < 0 ? `-₹${formatted}` : `₹${formatted}`;
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "p") {
        event.preventDefault();
        handlePrint(data);
      }
    };
    const handleAfterPrint = () => {
      setTimeout(() => {
        window.focus();
      }, 100);
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("afterprint", handleAfterPrint);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("afterprint", handleAfterPrint);
    };
  }, [data]);

  useEffect(() => {
    setTerms(storeSettings?.invoiceSettings?.termsAndConditions);
  }, [storeSettings?.invoiceSettings]);
  const grantotal = CurrencyConverter.toCurrency(data?.grandtotal || 0, "INR");
  const paidamount = CurrencyConverter.toCurrency(data?.paidamount || 0, "INR");
  const balanceDue = grantotal - paidamount;
  useEffect(() => {
    const upi = storeSettings?.paymentSettings?.upiId;

    const name = storeSettings?.paymentSettings?.bankDetails?.beneficiaryName;
    if (!upi) return; // skip until upi is available

    const upiUrl = `upi://pay?pa=${upi}&pn=${encodeURIComponent(name)}&cu=INR`;
    console.log("ip", upiUrl);
    QRCode.toDataURL(upiUrl)
      .then((url) => {
        setQrCodeDataUrl(url);
      })
      .catch((err) => {
        console.error("QR Code generation failed: ", err);
      });
  }, [
    storeSettings?.paymentSettings?.upiId,
    storeSettings?.paymentSettings?.bankDetails?.beneficiaryName,
  ]);

  return (
    <>
      <div className="invoice-scale">
        {selectedSize === "INVOICE" ? (
          <div className="tm_container">
            <div className="tm_invoice_wrap">
              <div className="tm_invoice tm_style1 tm_type1">
                <div className="tm_invoice_in">
                  <table width="100%" className="pdfcontent">
                    <tbody>
                      <tr>
                        <td width="50%" style={{ textAlign: "left" }}>
                          <div className="d-flex gap-3 align-items-start">
                            <div className="tm_logo">
                              {("/assets/images/logo-light.png" ||
                                settings?.saleProfileData?.image) && (
                                <img
                                  src={
                                    settings?.saleProfileData?.image
                                      ? uRLs.IMAGE_URL +
                                        "profile/" +
                                        settings?.saleProfileData?.image
                                      : "/assets/images/logo-light.png"
                                  }
                                  className="img-rounded logo mb-0"
                                  height="50"
                                />
                              )}
                            </div>
                            <div
                              style={{ fontSize: "12px", lineHeight: "16px" }}
                            >
                              <div style={{ fontWeight: "600" }}>
                                {settings?.saleProfileData?.title || ""}{" "}
                                {settings?.saleProfileData?.addressline1 || ""}{" "}
                                {settings?.saleProfileData?.addressline2 || ""}{" "}
                                {settings?.saleProfileData?.district || ""}{" "}
                                {settings?.saleProfileData?.country || ""} -{" "}
                                {settings?.saleProfileData?.pincode || ""}
                              </div>

                              <div>
                                Phone: {settings?.saleProfileData?.phone} |
                                Email: {settings?.saleProfileData?.email}
                              </div>

                              {settings?.saleProfileData?.fassi && (
                                <div>
                                  FSSAI: {settings?.saleProfileData?.fassi}
                                </div>
                              )}
                            </div>
                          </div>
                        </td>
                        <td width="50%" style={{ textAlign: "right" }}>
                          <div className="tm_primary_color tm_f50 tm_text_uppercase">
                            {globalData?.salemode &&
                              formatTrackMode(globalData?.salemode)}
                          </div>
                          {globalData?.status === "CANCELLED" && (
                            <span className="badge rounded-pill bg-label-danger mt-3 fs-15 tm_text_uppercase">
                              {globalData?.status}
                            </span>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="tm_invoice_info tm_mb20">
                    <div
                      className="tm_invoice_seperator tm_gray_bg"
                      style={{
                        backgroundColor:
                          selectedTheme?.templateTheme?.primaryColor,
                      }}
                    ></div>
                    <div className="tm_invoice_info_list">
                      <p className="tm_invoice_number tm_m0 mb-0 mt-3">
                        <b className="tm_primary_color">Invoice No: </b>{" "}
                        {globalData?.saleno}
                      </p>
                      <p className="tm_invoice_date tm_m0 mt-3">
                        <b className="tm_primary_color"> Date: </b>{" "}
                        {saleTime?.date}
                      </p>
                    </div>
                  </div>
                  <table width="100%" className="pdfcontent">
                    <tbody>
                      <tr>
                        <td width="100%" style={{ verticalAlign: "top" }}>
                          {globalData?.saleto &&
                            (globalData?.saleto?.name ||
                              globalData?.saleto?.addressline1 ||
                              globalData?.saleto?.addressline2 ||
                              globalData?.saleto?.state ||
                              globalData?.saleto?.district ||
                              globalData?.saleto?.country ||
                              globalData?.saleto?.pincode ||
                              globalData?.saleto?.phone ||
                              globalData?.saleto?.email ||
                              globalData?.saleto?.gstnumber ||
                              globalData?.saleto?.statecode ||
                              globalData?.saleto?.referid) && (
                              <div>
                                <div
                                  style={{
                                    fontSize: "14px",
                                    lineHeight: "22px",
                                    fontWeight: "600",
                                    marginBottom: "0px",
                                  }}
                                >
                                  Invoice To:
                                </div>
                                <div
                                  style={{
                                    fontSize: "12px",
                                    lineHeight: "18px",
                                    marginBottom: "2px",
                                  }}
                                >
                                  {globalData?.saleto?.name},{" "}
                                  {globalData?.saleto?.addressline1}{" "}
                                  {globalData?.saleto?.addressline2},{" "}
                                  {globalData?.saleto?.district},{" "}
                                  {globalData?.saleto?.state},{" "}
                                  {globalData?.saleto?.country} -{" "}
                                  {globalData?.saleto?.pincode}
                                  {globalData?.saleto?.phone && (
                                    <>
                                      {" "}
                                      , Phone: +91 {globalData?.saleto?.phone}
                                    </>
                                  )}
                                  {globalData?.saleto?.email && (
                                    <> , Email: {globalData?.saleto?.email}</>
                                  )}
                                  {globalData?.saleto?.gstnumber && (
                                    <> , GST: {globalData?.saleto?.gstnumber}</>
                                  )}
                                  {globalData?.saleto?.state && (
                                    <>
                                      {" "}
                                      , State: {globalData?.saleto?.state}{" "}
                                      [State Code:{" "}
                                      {globalData?.saleto?.statecode}]
                                    </>
                                  )}
                                  {globalData?.saleto?.referid && (
                                    <>
                                      {" "}
                                      , Reference No:{" "}
                                      {globalData?.saleto?.referid}
                                    </>
                                  )}
                                </div>
                              </div>
                            )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table
                    // className="items"
                    width="100%"
                    style={{
                      marginTop: "6px",
                      borderCollapse: "collapse",
                    }}
                    cellPadding="4"
                  >
                    <thead>
                      <tr>
                        <th
                          className="force-style"
                          style={{
                            width: "20px",
                            textAlign: "center",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          S.No
                        </th>
                        <th
                          className="force-style"
                          style={{
                            width: "240px",
                            textAlign: "center",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          Description
                        </th>
                        <th
                          className="force-style"
                          style={{
                            width: "120px",
                            textAlign: "center",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          Rate
                        </th>
                        <th
                          className="force-style"
                          style={{
                            width: "50px",
                            textAlign: "center",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          Qty
                        </th>
                        
                        <th
                          className="force-style"
                          style={{
                            width: "100px",
                            textAlign: "center",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          Gross Amount
                        </th>
                        <th
                          className="force-style"
                          style={{
                            width: "100px",
                            textAlign: "center",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          Taxable Value
                        </th>
                        <th
                          className="force-style"
                          style={{
                            width: "30px",
                            textAlign: "center",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          GST(%)
                        </th>
                        <th
                          className="force-style"
                          style={{
                            width: "100px",
                            textAlign: "center",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          GST Amount
                        </th>
                        <th
                          className="force-style"
                          style={{
                            width: "100px",
                            textAlign: "center",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          Total
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {globalData?.saleitems?.map((product, index) => (
                        <tr key={index}>
                          <td
                            className="force-style"
                            style={{
                              textAlign: "center",
                              fontSize: "12px",
                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            }}
                          >
                            {index + 1}
                          </td>
                          <td
                            className="force-style"
                            style={{
                              textAlign: "left",
                              fontSize: "12px",
                              width: "30%",
                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            }}
                          >
                            <div>{product.title}</div>
                            {product.imode === "SERVICE" && (
                              <div className="ms-0 fsz-10 lh-13 mb-1">
                                {product.description}
                              </div>
                            )}
                            {product.imode === "PRODUCT" && product.note && (
                              <div className="ms-0 fsz-10 mb-1">
                                {product?.note}
                              </div>
                            )}
                            {product.hsnsac && (
                              <div>
                                <span className="fw-medium">
                                  {" "}
                                  {product.imode === "SERVICE"
                                    ? "SAC:"
                                    : "HSN:"}
                                </span>{" "}
                                {product.hsnsac}
                              </div>
                            )}
                            {product.discount > 0 && (
                              <>
                                <div>
                                  <span className="fw-medium">MRP : </span> ₹
                                  {product.mrp}
                                </div>
                                <div>
                                  <span className="fw-medium">Discount : </span>{" "}
                                  - ₹{product.discount}
                                </div>
                              </>
                            )}
                          </td>
                          <td
                            className="force-style"
                            style={{
                              textAlign: "center",
                              fontSize: "12px",
                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            }}
                          >
                            ₹{product.soldprice}
                          </td>
                          <td
                            className="force-style"
                            style={{
                              textAlign: "center",
                              fontSize: "12px",
                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            }}
                          >
                            {product.quantity}{" "}
                            {(() => {
                              const unitCode = product?.isSecondaryUnit
                                ? product?.unitConfig?.secondaryUnitCode
                                : product?.unitConfig?.primaryUnitCode;
                              return unitCode || "";
                            })()}
                          </td>
                          
                          <td
                            className="force-style"
                            style={{
                              textAlign: "center",
                              fontSize: "12px",
                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            }}
                          >
                            ₹{product.lineTotalSoldPrice}
                          </td>
                          <td
                            className="force-style"
                            style={{
                              textAlign: "center",
                              fontSize: "12px",
                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            }}
                          >
                            ₹{product.lineTotalBasePrice}
                          </td>
                          <td
                            className="force-style"
                            style={{
                              textAlign: "center",
                              fontSize: "12px",
                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            }}
                          >
                            {product.taxpercentage}%
                          </td>
                          <td
                            className="force-style"
                            style={{
                              textAlign: "center",
                              fontSize: "12px",
                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            }}
                          >
                            ₹{product.lineTotalTaxAmount}
                          </td>
                          <td
                            className="force-style"
                            style={{
                              textAlign: "center",
                              fontSize: "12px",
                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            }}
                          >
                            ₹{product.lineTotalSoldPrice}
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td
                          colSpan={2}
                          className="force-style"
                          style={{
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        ></td>
                        <td
                          className="force-style"
                          style={{
                            textAlign: "center",
                            fontSize: "12px",
                            fontWeight: 600,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          Total
                        </td>
                        <td
                          className="force-style"
                          style={{
                            textAlign: "center",
                            fontSize: "12px",
                            fontWeight: 600,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        ></td>
                        <td
                          className="force-style"
                          style={{
                            textAlign: "center",
                            fontSize: "12px",
                            fontWeight: 600,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          ₹{globalData?.totalsoldprice}
                        </td>
                        <td
                          className="force-style"
                          style={{
                            textAlign: "center",
                            fontSize: "12px",
                            fontWeight: 600,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          ₹{globalData?.totalbaseprice}
                        </td>
                        <td
                          className="force-style"
                          style={{
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        ></td>
                        <td
                          className="force-style"
                          style={{
                            textAlign: "center",
                            fontSize: "12px",
                            fontWeight: 600,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          ₹{globalData?.totaltaxamount}
                        </td>
                        <td
                          className="force-style"
                          style={{
                            textAlign: "center",
                            fontSize: "12px",
                            fontWeight: 600,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          ₹{globalData?.grandtotal}
                        </td>
                      </tr>
                      <tr>
                        <td
                          className="force-style"
                          style={{
                            textAlign: "left",
                            fontSize: "12px",
                            fontWeight: 600,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                          colSpan="5"
                        >
                          Total Amount In Words
                        </td>
                        <td
                          className="force-style"
                          style={{
                            textAlign: "right",
                            fontSize: "12px",
                            fontWeight: 500,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                          colSpan="3"
                        >
                          Total Amount Before Tax
                        </td>
                        <td
                          className="force-style"
                          style={{
                            textAlign: "center",
                            fontSize: "12px",
                            fontWeight: 500,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          ₹{globalData?.totalbaseprice}
                        </td>
                      </tr>
                      <tr>
                        <td
                          className="force-style"
                          style={{
                            textAlign: "center",
                            fontSize: "12px",
                            fontWeight: 500,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                          colSpan="5"
                          rowSpan="5"
                        >
                          {globalData?.amountinwords}
                        </td>
                      </tr>
                      {globalData?.salefrom?.statecode &&
                      globalData?.saleto?.statecode &&
                      globalData?.salefrom?.statecode !==
                        globalData?.saleto?.statecode ? (
                        <tr>
                          <td
                            className="force-style"
                            style={{
                              textAlign: "right",
                              fontSize: "12px",
                              fontWeight: 500,
                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            }}
                            colSpan="3"
                          >
                            IGST
                          </td>
                          <td
                            className="force-style"
                            style={{
                              textAlign: "center",
                              fontSize: "12px",
                              fontWeight: 500,
                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            }}
                          >
                            ₹{globalData?.igstamount}
                          </td>
                        </tr>
                      ) : (
                        <>
                          <tr>
                            <td
                              className="force-style"
                              style={{
                                textAlign: "right",
                                fontSize: "12px",
                                fontWeight: 500,
                                "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                              }}
                              colSpan="3"
                            >
                              SGST
                            </td>
                            <td
                              className="force-style"
                              style={{
                                textAlign: "center",
                                fontSize: "12px",
                                fontWeight: 500,
                                "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                              }}
                            >
                              ₹{globalData?.sgstamount}
                            </td>
                          </tr>
                          <tr>
                            <td
                              className="force-style"
                              style={{
                                textAlign: "right",
                                fontSize: "12px",
                                fontWeight: 500,
                                "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                              }}
                              colSpan="3"
                            >
                              CGST
                            </td>
                            <td
                              className="force-style"
                              style={{
                                textAlign: "center",
                                fontSize: "12px",
                                fontWeight: 500,
                                "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                              }}
                            >
                              ₹{globalData?.cgstamount}
                            </td>
                          </tr>
                        </>
                      )}
                      <tr>
                        <td
                          className="force-style"
                          style={{
                            textAlign: "right",
                            fontSize: "12px",
                            fontWeight: 500,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                          colSpan="3"
                        >
                          TOTAL
                        </td>
                        <td
                          className="force-style"
                          style={{
                            textAlign: "center",
                            fontSize: "12px",
                            fontWeight: 500,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          ₹{globalData?.totalsoldprice}
                        </td>
                      </tr>
                      <tr>
                        <td
                          className="force-style"
                          style={{
                            textAlign: "right",
                            fontSize: "14px",
                            fontWeight: 600,
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                          colSpan="3"
                        >
                          Grand Total (Rounded)
                        </td>
                        <td
                          className="force-style"
                          style={{
                            textAlign: "center",
                            fontSize: "14px",
                            fontWeight: 600,
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          ₹{globalData?.grandtotal}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  {/* <table width="100%">
                        <tbody>
                          <tr>
                            <td
                              style={{
                                fontSize: "13px",
                                fontWeight: 600,
                                textAlign: "center",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              Your Total Discount : ₹
                              {CurrencyConverter.toCurrency(
                                isViewData?.totaldiscount || 0,
                                "INR",
                              )}
                             
                            </td>
                          </tr>
                        </tbody>
                      </table>
                                                       */}

                  <div
                    className="d-flex justify-content-between align-items-end "
                    style={{ marginTop: "15px", width: "100%" }}
                  >
                    <div className="text-center flex-grow-1">
                      <div
                        className="fs-20 fw-bold mb-2"
                        style={{
                          fontSize: "13px",
                          fontWeight: 600,
                          textAlign: "center",
                          padding: "8px",
                          color: "black",
                        }}
                      >
                        Your Total Discount : ₹ {globalData?.totaldiscount}
                      </div>
                      <div className="fs-20 fw-bold">
                        ***** Thank You! Visit Us Again *****
                      </div>
                      {storeSettings?.negobillBranding && (
                        <div className="mt-1">
                          <div className="fs-20 fw-bold">Powered By</div>
                          <div className="fs-20 fw-bold">www.NegoBill.com</div>
                        </div>
                      )}
                    </div>
                    <div style={{ textAlign: "right", paddingBottom: "8px" }}>
                      <div className="p-0" style={{ fontSize: "14px" }}>
                        Issued By, Signature
                      </div>
                      {storeSettings?.invoiceSettings?.signature && (
                        <div className="mt-1">
                          <img
                            src={
                              uRLs.IMAGE_URL +
                              storeSettings?.invoiceSettings?.signature
                            }
                            width={150}
                            alt="Signature"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : selectedSize === "BILL" ? (
          <div className="tm_container">
            <div className="tm_invoice_wrap">
              <div className="tm_invoice tm_style1 tm_type1">
                <div className="tm_invoice_in">
                  <table width="100%" className="pdfcontent">
                    <tbody>
                      <tr>
                        <td width="50%" style={{ textAlign: "left" }}>
                          <div className="d-flex gap-3 align-items-start">
                            <div className="tm_logo">
                              {(settings?.saleProfileData?.image ||
                                "/assets/images/logo-light.png") && (
                                <img
                                  src={
                                    settings?.saleProfileData?.image
                                      ? uRLs.IMAGE_URL +
                                        "profile/" +
                                        settings?.saleProfileData?.image
                                      : "/assets/images/logo-light.png"
                                  }
                                  className="img-rounded logo mb-0"
                                  height="50"
                                />
                              )}
                            </div>
                            <div
                              style={{ fontSize: "12px", lineHeight: "16px" }}
                            >
                              <div style={{ fontWeight: "600" }}>
                                {settings?.saleProfileData?.title || ""}{" "}
                                {settings?.saleProfileData?.addressline1 || ""}{" "}
                                {settings?.saleProfileData?.addressline2 || ""}{" "}
                                {settings?.saleProfileData?.district || ""}{" "}
                                {settings?.saleProfileData?.country || ""} -{" "}
                                {settings?.saleProfileData?.pincode || ""}
                              </div>

                              <div>
                                Phone: {settings?.saleProfileData?.phone} |
                                Email: {settings?.saleProfileData?.email}
                              </div>

                              {settings?.saleProfileData?.fassi && (
                                <div>
                                  FSSAI: {settings?.saleProfileData?.fassi}
                                </div>
                              )}
                            </div>
                          </div>
                        </td>
                        <td width="50%" style={{ textAlign: "right" }}>
                          <div className="tm_primary_color tm_f50 tm_text_uppercase">
                            {selectedSize && formatTrackMode(selectedSize)}
                          </div>
                          {isViewData.status === "CANCELLED" && (
                            <span className="badge rounded-pill bg-label-danger mt-3 fs-15 tm_text_uppercase">
                              {isViewData.status}
                            </span>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="tm_invoice_info tm_mb20">
                    <div
                      className="tm_invoice_seperator tm_gray_bg"
                      style={{
                        backgroundColor:
                          selectedTheme?.templateTheme?.primaryColor,
                      }}
                    ></div>
                    <div className="tm_invoice_info_list">
                      <p className="tm_invoice_number tm_m0 mb-0 mt-3">
                        <b className="tm_primary_color">Bill No: </b>{" "}
                        {isViewData.saleno}
                      </p>
                      <p className="tm_invoice_date tm_m0 mt-3">
                        <b className="tm_primary_color"> Date: </b>{" "}
                        {saleTime.date}
                      </p>
                    </div>
                  </div>
                  <table width="100%" className="pdfcontent">
                    <tbody>
                      <tr>
                        <td width="100%" style={{ verticalAlign: "top" }}>
                          {isViewData.saleto &&
                            (isViewData.saleto.name ||
                              isViewData.saleto.addressline1 ||
                              isViewData.saleto.addressline2 ||
                              isViewData.saleto.state ||
                              isViewData.saleto.district ||
                              isViewData.saleto.country ||
                              isViewData.saleto.pincode ||
                              isViewData.saleto.phone ||
                              isViewData.saleto.email ||
                              isViewData.saleto.gstnumber ||
                              isViewData.saleto.statecode ||
                              isViewData.saleto.referid) && (
                              <div>
                                <div
                                  style={{
                                    fontSize: "14px",
                                    lineHeight: "22px",
                                    fontWeight: "600",
                                    marginBottom: "0px",
                                  }}
                                >
                                  Bill To:
                                </div>
                                <div
                                  style={{
                                    fontSize: "12px",
                                    lineHeight: "18px",
                                    marginBottom: "2px",
                                  }}
                                >
                                  {isViewData?.saleto?.name},{" "}
                                  {isViewData?.saleto?.addressline1}{" "}
                                  {isViewData?.saleto?.addressline2},{" "}
                                  {isViewData?.saleto?.district},{" "}
                                  {isViewData?.saleto?.state},{" "}
                                  {isViewData?.saleto?.country} -{" "}
                                  {isViewData?.saleto?.pincode}
                                  {isViewData?.saleto?.phone && (
                                    <>
                                      {" "}
                                      , Phone: +91 {isViewData?.saleto?.phone}
                                    </>
                                  )}
                                  {isViewData?.saleto?.email && (
                                    <> , Email: {isViewData?.saleto?.email}</>
                                  )}
                                  {isViewData?.saleto?.gstnumber && (
                                    <> , GST: {isViewData?.saleto?.gstnumber}</>
                                  )}
                                  {isViewData?.saleto?.state && (
                                    <>
                                      {" "}
                                      , State: {isViewData?.saleto?.state}{" "}
                                      [State Code:{" "}
                                      {isViewData?.saleto?.statecode}]
                                    </>
                                  )}
                                  {isViewData?.saleto?.referid && (
                                    <>
                                      {" "}
                                      , Reference No:{" "}
                                      {isViewData?.saleto?.referid}
                                    </>
                                  )}
                                </div>
                                <div
                                  style={{
                                    fontSize: "12px",
                                    lineHeight: "18px",
                                    marginBottom: "0px",
                                  }}
                                >
                                  <div>
                                    {isViewData.saleto?.addressline1 || ""}{" "}
                                    {isViewData.saleto?.addressline2 || ""}{" "}
                                    {isViewData.saleto?.state || ""}{" "}
                                    {isViewData.saleto?.district || ""}{" "}
                                    {isViewData.saleto?.country || ""} -{" "}
                                    {isViewData.saleto?.pincode || ""}
                                  </div>
                                  {isViewData.saleto?.phone && (
                                    <div>
                                      Phone: +91 {isViewData.saleto?.phone}
                                    </div>
                                  )}
                                  {isViewData.saleto?.email && (
                                    <div>Email: {isViewData.saleto?.email}</div>
                                  )}
                                  {isViewData.saleto?.gstnumber && (
                                    <div>
                                      <strong>GST:</strong>{" "}
                                      {isViewData.saleto?.gstnumber}
                                    </div>
                                  )}
                                  {isViewData.saleto?.state && (
                                    <div>
                                      <strong>State:</strong>{" "}
                                      {isViewData.saleto?.state} [ State Code :
                                      {isViewData.saleto?.statecode || ""} ]
                                    </div>
                                  )}
                                  {isViewData.saleto?.referid && (
                                    <div>
                                      <strong>Reference No:</strong>{" "}
                                      {isViewData.saleto?.referid}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table
                    // className="items"
                    width="100%"
                    style={{
                      marginTop: "6px",
                      borderCollapse: "collapse",
                    }}
                    cellPadding="4"
                  >
                    <thead>
                      <tr>
                        <th
                          className="force-style"
                          style={{
                            width: "20px",
                            textAlign: "center",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            // border: `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          }}
                        >
                          S.No
                        </th>
                        <th
                          className="force-style"
                          style={{
                            textAlign: "center",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          Description
                        </th>
                        <th
                          className="force-style"
                          style={{
                            width: "60px",
                            textAlign: "center",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          Rate (Per Unit)
                        </th>
                        <th
                          className="force-style"
                          style={{
                            width: "60px",
                            textAlign: "center",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          Qty
                        </th>
                        <th
                          className="force-style"
                          style={{
                            width: "60px",
                            textAlign: "center",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          Total
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {isViewData.saleitems?.map((product, index) => (
                        <tr key={index}>
                          <td
                            className="force-style"
                            style={{
                              textAlign: "center",
                              fontSize: "12px",
                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            }}
                          >
                            {index + 1}
                          </td>
                          <td
                            className="force-style"
                            style={{
                              textAlign: "left",
                              fontSize: "12px",
                              width: "45%",
                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            }}
                          >
                            <div>{product.title}</div>
                            {product.imode === "SERVICE" && (
                              <div className="ms-0 fsz-10 lh-13 mb-1">
                                {product.description}
                              </div>
                            )}
                            {product.imode === "PRODUCT" && product.note && (
                              <div className="ms-0 fs-12 text-truncate-description text-muted">
                                {product?.note}
                              </div>
                            )}
                            {product.hsnsac && (
                              <div>
                                <span className="fw-medium">
                                  {" "}
                                  {product.imode === "SERVICE"
                                    ? "SAC:"
                                    : "HSN:"}{" "}
                                </span>{" "}
                                {product.hsnsac}
                              </div>
                            )}
                            {product.discount > 0 && (
                              <>
                                <div>
                                  <span className="fw-medium">MRP : </span> ₹
                                  {CurrencyConverter.toCurrency(
                                    product.mrp || 0,
                                    "INR"
                                  )}
                                </div>
                                <div>
                                  <span className="fw-medium">Discount : </span>{" "}
                                  - ₹
                                  {CurrencyConverter.toCurrency(
                                    product.discount || 0,
                                    "INR"
                                  )}
                                </div>
                              </>
                            )}
                          </td>
                          <td
                            className="force-style"
                            style={{
                              textAlign: "center",
                              fontSize: "12px",
                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            }}
                          >
                            ₹
                            {CurrencyConverter.toCurrency(
                              product.soldprice || 0,
                              "INR"
                            )}
                          </td>
                          <td
                            className="force-style"
                            style={{
                              textAlign: "center",
                              fontSize: "12px",
                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            }}
                          >
                            {product.quantity}
                          </td>
                          <td
                            className="force-style"
                            style={{
                              textAlign: "center",
                              fontSize: "12px",
                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            }}
                          >
                            ₹
                            {CurrencyConverter.toCurrency(
                              product.lineTotalSoldPrice || 0,
                              "INR"
                            )}
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td
                          className="force-style"
                          style={{
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                          }}
                          colSpan={2}
                        ></td>
                        <td
                          className="force-style"
                          style={{
                            textAlign: "center",
                            fontSize: "12px",
                            fontWeight: 600,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          Total
                        </td>
                        <td
                          className="force-style"
                          style={{
                            textAlign: "center",
                            fontSize: "12px",
                            fontWeight: 600,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          {isViewData.totalqty}
                        </td>
                        <td
                          className="force-style"
                          style={{
                            textAlign: "center",
                            fontSize: "12px",
                            fontWeight: 600,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          ₹
                          {CurrencyConverter.toCurrency(
                            isViewData.totalsoldprice || 0,
                            "INR"
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td
                          className="force-style"
                          style={{
                            textAlign: "left",
                            fontSize: "12px",
                            fontWeight: 600,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                          colSpan="2"
                        >
                          Total Amount In Words
                        </td>
                        <td
                          className="force-style"
                          style={{
                            textAlign: "right",
                            fontSize: "12px",
                            fontWeight: 500,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                          colSpan="2"
                        >
                          Grand Total
                        </td>
                        <td
                          className="force-style"
                          style={{
                            textAlign: "center",
                            fontSize: "12px",
                            fontWeight: 500,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          ₹
                          {CurrencyConverter.toCurrency(
                            isViewData.grandtotal || 0,
                            "INR"
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td
                          className="force-style"
                          style={{
                            textAlign: "center",
                            fontSize: "12px",
                            fontWeight: 500,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                          colSpan="2"
                          rowSpan="5"
                        >
                          {isViewData.amountinwords}
                        </td>
                      </tr>
                      <tr>
                        <td
                          className="force-style"
                          style={{
                            textAlign: "right",
                            fontSize: "14px",
                            fontWeight: 600,
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                          colSpan="2"
                        >
                          Grand Total (Rounded)
                        </td>
                        <td
                          className="force-style"
                          style={{
                            textAlign: "center",
                            fontSize: "14px",
                            fontWeight: 600,
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          ₹
                          {CurrencyConverter.toCurrency(
                            isViewData.grandtotal || 0,
                            "INR"
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table width="100%">
                    <tbody>
                      <tr>
                        <td
                          style={{
                            fontSize: "13px",
                            fontWeight: 600,
                            textAlign: "center",
                            padding: "8px",
                            color: "black",
                          }}
                        >
                          Your Total Discount : ₹
                          {CurrencyConverter.toCurrency(
                            isViewData.totaldiscount || 0,
                            "INR"
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  {/* { data?.grandtotal >0 &&(
                                  <table
                                  className="items"
                                  width="38%"
                                  style={{
                                    marginTop: "4px",
                                    // borderCollapse: "collapse",
                                  }}
                                  cellPadding="4"
                                >
                                  <thead>
                                    <tr>
                                      <th
                                        colSpan={2}
                                        className="force-style"
                                        style={{
                                          width: "100%",
                                          textAlign: "center",
                                          "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            "--th-bg": selectedTheme?.templateTheme?.primaryColor,
                                            "--th-color": selectedTheme?.templateTheme?.foregroundColor,
                                        }}
                                      >
                                        Payment Mode
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {((data.cashamount || 0) - (data.cashchange || 0))>0 &&(
                                    <tr>
                                      <td className="force-style"
                                            style={{
                                              textAlign: "start",
                                              fontSize: "12px",
                                              width: "10%",
                                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `
                                            }}>Cash</td>
                                      <td
                                        className="force-style"
                                        style={{
                                          textAlign: "start",
                                          fontSize: "12px",
                                          fontWeight:"600",
                                          width: "10%",
                                          "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `
                                        }}
                                      >
                                        {formatCurrency(
                                  (data.cashamount || 0) - (data.cashchange || 0)
                                )}
                                      </td>
                                    </tr>)}
                                    {((data.cardamount || 0) - (data.cardchange || 0))>0&&(
                                    <tr>
                                      <td  className="force-style"
                                            style={{
                                              textAlign: "start",
                                              fontSize: "12px",
                                              width: "10%",
                                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `
                                            }}>Card</td>
                                      <td
                                        className="force-style"
                                        style={{
                                          textAlign: "start",
                                          fontSize: "12px",
                                          fontWeight:"600",
                                          width: "10%",
                                          "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `
                                        }}
                                      >
                                        {formatCurrency(
                                  (data.cardamount || 0) - (data.cardchange || 0)
                                )}
                                      </td>
                                    </tr>)}
                                    {((data.onlineamount || 0) - (data.onlinechange || 0))>0 &&(
                                    <tr>
                                      <td className="force-style"
                                            style={{
                                              textAlign: "start",
                                              fontSize: "12px",
                                              width: "10%",
                                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `
                                            }}>OnlineAmount</td>
                                      <td
                                        className="force-style"
                                        style={{
                                          textAlign: "start",
                                          fontSize: "12px",
                                          width: "10%",
                                          fontWeight:"600",
                                          "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `
                                        }}
                                      >
                                        {formatCurrency(
                                  (data.onlineamount || 0) - (data.onlinechange || 0)
                                )}
                                      </td>
                                    </tr>)}
                                    {((data.upiamount || 0) - (data.upichange || 0))>0 &&(
                                    <tr>
                                      <td className="force-style"
                                            style={{
                                              textAlign: "start",
                                              fontSize: "12px",
                                              width: "10%",
                                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `
                                            }}>UPI</td>
                                      <td
                                       className="force-style"
                                       style={{
                                         textAlign: "start",
                                         fontSize: "12px",
                                         width: "10%",
                                         fontWeight:"600",
                                         "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `
                                       }}
                                      >
                                        {formatCurrency(
                                  (data.upiamount || 0) - (data.upichange || 0)
                                )}
                                      </td>
                                    </tr>)}
                                    {((data.paylateramount || 0) - (data.paylaterchange || 0))>0 &&(
                                    <tr>
                                      <td className="force-style"
                                            style={{
                                              textAlign: "start",
                                              fontSize: "12px",
                                              width: "10%",
                                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `
                                            }}>BalanceDue</td>
                                      <td
                                        className="force-style"
                                        style={{
                                          textAlign: "start",
                                          fontSize: "12px",
                                          width: "10%",
                                          fontWeight:"600",
                                          "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `
                                        }}
                                      >
                                        {formatCurrency(
                                  (data.paylateramount || 0) -
                                    (data.paylaterchange || 0)
                                )}
                                      </td>
                                    </tr>)}
                                  </tbody>
                                </table>
                                  )}
                                    <div className="mt-2 fs-20 d-flex justify-content-center fw-bold">
                                            <span
                                            >
                                              ***** Thank You! Visit Us Again *****
                                            </span>
                                          </div>
                                          {storeSettings?.negobillBranding && (
                                            <>
                                          <div className="mt-1 fs-20 d-flex justify-content-center fw-bold">
                                            <span
                                            >
                                              Powered By
                                            </span>
                                          </div>
                                          <div className=" fs-20 d-flex justify-content-center fw-bold">
                                            <span
                                            >
                                              www.NegoBill.com
                                            </span>
                                          </div>
                                          </>)}
                                          <table width="100%">
                                      <tbody>
                                        <tr>
                                        {terms?.length > 0 && (
                                          <td
                                            style={{
                                              padding: "8px",
                                            }}
                                            width="70%"
                                          >
                                            <div
                                              className="fs-13 fw-600"
                                              style={{
                                                textAlign: "left",
                                                color: "black",
                                              }}
                                            >
                                              Terms & Conditions
                                            </div>
                                            <div className="terms-box">{terms}</div>
                                          </td>
                                            )}
                                          <td
                                            style={{
                                              padding: "8px",
                                              marginTop: "15px",
                                            }}
                                            className="d-flex align-items-start justify-content-end"
                                          >
                                            <div>
                                            {storeSettings?.invoiceSettings
                                                ?.signature && (
                                                <div className="text-end p-0 fw-bold ">
                                                  <img
                                                    src={
                                                      uRLs.IMAGE_URL +
                                                      storeSettings?.invoiceSettings
                                                        ?.signature
                                                    }
                                                    width={150}
                                                  />
                                                </div>
                                              )}
                                              <div className="text-end p-0">
                                                Issued By,Signature
                                              </div>
                                             <div className="text-end p-0 fw-bold ">
                                                {data?.salefrom?.title}
                                              </div> 
                                              
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table> */}
                  {/* <table
                        
                        width="100%"
                        style={{ borderCollapse: "collapse" }}
                        cellPadding="8"
                      >
                        <tbody>
                          <tr>
                            <td
                              className="force-style"
                              style={{
                                verticalAlign: "middle",
                                width: "52.5%",
                                "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                textAlign: "left",
                                padding: "8px",
                              }}
                            >
                              <span
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 600,
                                }}
                              >
                                Declaration:
                              </span>
                              <br />
                              <span style={{ fontSize: "12px" }}>
                                We declare that this bill recipet shows the actual
                                price of the goods described and that all particulars
                                are true and correct.
                              </span>
                            </td>
                            <td
                              className="force-style"
                              style={{
                                width: "50%",
                                fontSize: "12px",
                                fontWeight: "500",
                                "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                textAlign: "center",
                                padding: "8px",
                              }}
                            >
                              * Computer Generated Document No sign Required
                            </td>
                          </tr>
                        </tbody>
                      </table> */}
                  <div
                    className="d-flex justify-content-between align-items-end "
                    style={{ marginTop: "15px", width: "100%" }}
                  >
                    <div className="text-center flex-grow-1">
                      <div
                        className="fs-20 fw-bold mb-2"
                        style={{
                          fontSize: "13px",
                          fontWeight: 600,
                          textAlign: "center",
                          padding: "8px",
                          color: "black",
                        }}
                      >
                        Your Total Discount : ₹{" "}
                        {CurrencyConverter.toCurrency(
                          isViewData?.totaldiscount || 0,
                          "INR"
                        )}
                      </div>
                      <div className="fs-20 fw-bold">
                        ***** Thank You! Visit Us Again *****
                      </div>
                      {storeSettings?.negobillBranding && (
                        <div className="mt-1">
                          <div className="fs-20 fw-bold">Powered By</div>
                          <div className="fs-20 fw-bold">www.NegoBill.com</div>
                        </div>
                      )}
                    </div>
                    <div style={{ textAlign: "right", paddingBottom: "8px" }}>
                      <div className="p-0" style={{ fontSize: "14px" }}>
                        Issued By, Signature
                      </div>
                      {storeSettings?.invoiceSettings?.signature && (
                        <div className="mt-1">
                          <img
                            src={
                              uRLs.IMAGE_URL +
                              storeSettings?.invoiceSettings?.signature
                            }
                            width={150}
                            alt="Signature"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="default-content">
            <p>No content available for this sale mode.</p>
          </div>
        )}
      </div>

      <div
        className="modal-footer d-block mt-2"
        style={{
          position: "sticky",
          bottom: -4,
          background: "#fff",
          zIndex: 10,
          borderTop: "1px solid #e0e0e0",
        }}
      >
        {payment && <div className="fw-600 mb-2 font-14">PAYMENT SUMMARY</div>}
        {payment && (
          <table
            className="items table-bordered mb-3"
            width="100%"
            cellPadding="4"
          >
            <tbody className="text-center">
              <tr>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    cursor: isViewData.cashamount > 0 ? "pointer" : "default",
                    padding: "2px 8px",
                  }}
                  onClick={(e) => {
                    if (isViewData.cashamount > 0) {
                      cashRef.current.openPopover(e);
                    }
                  }}
                >
                  <div
                    className={
                      isViewData?.cashamount > 0
                        ? "badge rounded-pill bg-label-moon d-inline-flex align-items-center"
                        : "d-inline-flex align-items-center"
                    }
                    style={{ gap: "4px", fontSize: "12px" }}
                  >
                    CASH
                    {isViewData?.cashamount > 0 && <ShowIcon/>}
                  </div>
                </th>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                >
                  CARD
                </th>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                >
                  ONLINE
                </th>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                >
                  UPI
                </th>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    cursor:
                      isViewData?.paylateramount > 0 ? "pointer" : "default",
                    padding: "2px 8px",
                    fontSize: "12px",
                  }}
                  onClick={(e) => {
                    if (isViewData?.paylateramount > 0) {
                      paylaterRef.current.openPopover(e);
                    }
                  }}
                >
                  <div
                    className={
                      isViewData?.paylateramount > 0
                        ? "badge rounded-pill bg-label-fire d-inline-flex align-items-center"
                        : "d-inline-flex align-items-center"
                    }
                    style={{ gap: "4px" }}
                  >
                    PAYLATER
                    {isViewData?.paylateramount > 0 && (
                      <ShowIcon iClass={"ms-1"}/>
                    )}
                  </div>
                </th>
              </tr>
              <tr>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.cashamount || 0) -
                      (isViewData?.cashchange || 0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.cardamount || 0) -
                      (isViewData?.cardchange || 0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.onlineamount || 0) -
                      (isViewData?.onlinechange || 0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.upiamount || 0) - (isViewData?.upichange || 0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.paylateramount || 0) -
                      (isViewData?.paylaterchange || 0)
                  )}
                </td>
              </tr>
            </tbody>
            <CashButton
              ref={cashRef}
              trackId={isViewData?.boxCashInfo?.trackid}
              trackMode={isViewData?.boxCashInfo?.trackmode}
            />
            <PayLaterButton
              ref={paylaterRef}
              trackId={isViewData?.paylaterInfo?.trackid}
              customerId={isViewData?.paylaterInfo?.customerid}
              trackMode={isViewData?.paylaterInfo?.trackmode}
            />
          </table>
        )}
        {downloadbtn && (
          <div className="my-2 d-flex gap-2">
            <div className="btn-group text-right align-items-center">
              {print ? (
                <button
                  className="btn bg-label-animal btn-sm pb-0 font-12"
                  disabled
                >
                  <CircularProgress size={12} className="text-white" />
                </button>
              ) : (
                <>
                  <button
                    onClick={() => handlePrint(data)}
                    className="btn bg-label-animal shadow-none btn-sm font-12"
                    id="printreceiptbtn"
                  >
                    <PrinterIcon iClass={"fs-12"}/> Print
                  </button>
                </>
              )}
            </div>

            {download ? (
              <button
                className="btn btn-warning btn-sm pb-0 text-right"
                disabled
              >
                <CircularProgress size={18} className="text-black" />
              </button>
            ) : (
              <button
                className="btn btn-warning btn-sm text-right"
                id="generatebillpdfbtn"
                onClick={() => handleDownload(data)}
              >
                <DownloadIcon iClass={"fs-15"}/>
              </button>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default HalfA4_1;
